// ================================================================
// PLATINUM PET FOOD FINDER v9.35 — Dog-First MVP
// v9.35 (2026-08-18): wet_menu_conflict v payloadih (submit + email flow) —
//                     last-resort MENU alergen konflikt (v9.34) zdaj potuje
//                     do Supabase/QA (WARN namesto ERR) in Email Flowa
//                     (Email #1 skrije/oznaci wet sekcijo). Frontend UI enak.
// v9.34 (2026-08-17): Last-resort MENU (nobena mokra brez alergenov): (1) utezen
//                     sort — mesni/zivalski alergen steje 10x vec kot rastlinski
//                     (Krompir/Riz), zato zmaga npr. MENU Fish namesto MENU Chicken;
//                     (2) byMode +menuConflict; (3) renderMenuAllergenNotice —
//                     rumeno opozorilo na wet kartici s spornimi alergeni in
//                     priporocilom suhe hrane / posveta z veterinarjem.
// v9.33 (2026-08-04): UX fix za flat popust — WET_QTY je zdaj flat 11 % za 2×-6×,
//                     zato je €/dan v qty tabeli povsod enak (5,04 €/dan ×4 vrstice).
//                     renderQtyTable pri flat tabeli namesto €/dan pokaže rastoči
//                     prihranek ("prihraniš 9,04 € … 27,12 €"). Suha hrana (stopnjevan
//                     popust) ostane z €/dan. Auto-detect: če bo popust spet
//                     stopnjevast, se €/dan sam vrne.
// v9.32 (2026-08-04): FIX qty rounding — Shopify app z novo discount konfiguracijo
//                     zaokroža na TOTALU: total = round(base × qty × (1−d)).
//                     Prej (v9.27-v9.31): TRUNC popusta per-unit — z novimi cenami
//                     dajalo +2 do +4 cente nad Shopify (npr. Vetactive 5kg 6×:
//                     178.02 vs Shopify 177.98). renderQtyTable + calcBestCpdDry.
// v9.31 (2026-08-04): NOV CENIK + nove qty lestvice (Shopify že live).
//                     DRY_QTY 2×: 11% → 10% (3×/4×/6× nespremenjeno 20/23/28).
//                     WET_QTY: 4/6/8/10% → flat 11% za 2×-6×.
//                     Hardcoded fallback cene posodobljene na nov cenik
//                     (PRODUCTS, MENU, UPSELLS — runtime jih sicer prepiše Supabase).
// v9.30 (2026-04-24): OralClean+Care Classic dodan kot dog upsell (prej ni bil
//                     v UPSELLS arrayu). Nova cena 35.86\u20ac (prej 29.98\u20ac v cat).
//                     Trigger: ['senior','default'] \u2014 senior dogs + default
//                     fallback za healthy adults (Stars se tudi prika\u017eejo).
//                     Supabase rule dodana: starost=senior \u2192 OralClean+Care Classic.
//                     Desc + email blurb osve\u017eena (master doc v1.1 align).
//                     Cat quiz: enaka cena + desc update (pet-food-finder-cat.js).
// v9.29 (2026-04-21): FIX 2x QA Gmail alert \u2014 submitEmailFallback() na
//                     result strani je poleg direktnega Email Flow klica \u0161e
//                     re-klical submitQuizData(RES_CACHE), kar je re-sprozilo
//                     Dog Quiz Submit workflow \u2192 2. Supabase INSERT +
//                     2. QA Gmail alert. Odstranjen submitQuizData re-call,
//                     ohranjen direkten fetch v pet-food-finder-email webhook.
//                     Rezultat: 1 Quiz Submit (ob quiz koncu), 1 Email Flow
//                     klic (ob email vnosu), 1 QA alert namesto 2.
// v9.28 (2026-04-17): FIX "Že od X €/dan" double-rounding. calcBestCpdDry helper
//                     uporablja Shopify TRUNC-on-discount (enako kot renderQtyTable).
//                     Prej: pre-round cpd × (1-d) → 1 cent razlika od qty table.
//                     Zdaj: TRUNC total / (g × qty) × gpd → usklajeno. Dry + wet.
// v9.27 (2026-04-17): FIX qty discount pricing — ujema se s Shopify per-line-item rounding.
//                     PREJ: round(base × qty × (1-d)) na totalu → cene par centov pod Shopify.
//                     ZDAJ: TRUNC(base × d, 2) per unit × qty → odšteje od (base×qty).
//                     Velik vpliv pri visokih popustih (28%): 5kg 6×29.96 bilo ~129.43 → 129.48.
// ================================================================
// v9.26 (2026-04-15): Image sync iz Supabase featured_image (vse 71 produktov dinamično)
//                     Slike se posodobijo avtomatsko ko jih spremenimo v Shopify
// v9.25 (2026-03-17): Price sync — dinamične cene iz Supabase ob vsakem zagonu kviza
//                     Fallback na hardcoded cene če Supabase ne odgovori
// v9.24 (2026-03-16): FIX: Puppy privzeto pakiranje gleda adultWeightKg (ne trenutno težo)
//                     8 kg puppy z adult 30 kg zdaj dobi 5 kg paket (prej 1.5 kg)
//                     FIX: Growth factor interpolacija (ne nearest bracket) — brez lažnih opozoril
// v9.23 (2026-03-12): FIX: Postopni prehod poravnan z email spec + veterinarskim standardom
//                     3 koraki (40%→70%→100%) → 4 koraki (25%→50%→75%→100% v 7 dneh)
// v9.22 (2026-03-11): FIX: Progress bar counter ("Vprašanje X od 7") se zdaj prikaže
//                     pod progress barom (ločen DOM element), ne ob strani v flex container.
// v9.21 (2026-03-11): Email capture optimizacija — personaliziran CTA ("Pošlji Rex plan
//                     na email →"), social proof (števec + review), progress "Vprašanje X
//                     od 7" + "Skoraj končano", mini-insights (BC/aktivnost/alergije),
//                     subtilnejši skip link.
// v9.20 (2026-03-10): FIX: Wet food last resort — sort by fewest allergen overlaps
//                     instead of ignoring allergens. Hero (10 allergens) now gets
//                     Duck+Turkey (1 overlap) instead of Beef+Chicken (3 overlaps).
// v9.19 (2026-03-10): FIX: ga4 quiz_complete crash (res.dryProducts undefined)
//                     ki je blokiral submitQuizData() → Supabase + QA email.
// v9.18 (2026-03-10): GA4 event tracking (quiz_start, quiz_complete, quiz_cta_click,
//                     quiz_email_submit). n8n email UTM (utm_medium=email).
// v9.17 (2026-03-10): UTM tracking na vseh CTA linkih (atc, notifyMe).
//                     utm_source=pet-food-finder, utm_content={handle} za GA4 attribution.
// v9.16 (2026-03-10): Teksti VERZIJA2: benefit-first preoblikovanje vseh bulletov.
//                     Picky: "dišijo po svežem mesu". Puppy/Senior/Light/Hypo: konkretnejši.
//                     Novi Piščanec/Govedina flavor bulleti. Hypo merged (3→3 bulletov).
//                     Mokra: "čvrsti kakci", "Samo sveže meso". 6× upsell desc.
//                     Bug fix: vet-senior special:'senior' za genWhyIntro uvod.
// v9.15 (2026-03-09): Web/email opisi usklajeni. "Neodporljiv okus" → "Pravi koščki
//                     mesa v omaki". genWhyIntro: "Za Xovo" → "Ker ima X", brez "mu".
//                     genBenefits: picky vključuje 'sometimes', normal text popravljen.
// v9.14 (2026-03-09): emailRow +dry_handle, dry_img, dry_alt_handle, dry_alt_img,
//                     wet_handle, wet_img, fallback_notice (obe email poti).
//                     Transition tekst usklajen z emailom.
// v9.13 (2026-03-09): submitQuizData() → fetch pet-food-finder-email webhook
//                     ko S.email obstaja (screen 7 + fallback). Prej samo fallback.
// v9.12 (2026-03-09): submitEmailFallback() → fetch pet-food-finder-email webhook
//                     (snake_case payload z row wrapper za Klaviyo Email Flow)
// v9.11 (2026-03-09): submitQuizData +dryCostBestCpd, dryAltBestCpd
//                     (cheapest variant × max qty discount za email razpon)
// v9.10 (2026-03-08): Fallback notice: dinamičen produkt name (ne hardcoded
//                     Hypoallergenic), header subtitle +alergeni, last resort
//                     upošteva eligibility filter (Light ne za high activity)
// v9.8 (2026-03-08): Email validacija na results page (clearEmErr,
//                     isValidEmail regex, rdeč error msg + obroba)
// v9.7 (2026-03-08): Email sekcija: PDF odstranjen, "plan prehrane",
//                     layout stacked (ne side-by-side), bele barve
// v9.6 (2026-03-07): PDF payload: +dryVariants, dryQty, dryAlt,
//                     dryAltHandle, dryImg, wetImg za polni PDF
// v9.5 (2026-03-07): Email flow: submitQuizData +4 polja (dryCostCpm,
//                     dryHandle, wetHandle, wetCostCpm), email UX teksti
// v9.0 (2026-03-07): BC string fix (parseInt), alt fallback fix,
//                     CSS: gumb bližje, sticky slika off
// v8.7: Base scores rebalans, hasAllergies fix, Senior alt, senior meje
// v8.4: Alt logika v2, collapsible qty, mobile overflow, sticky CTA wet
// v8.2: BC4=×0.95, kcal sync s Supabase
// v8.1: kcal pipeline, RER clamp, eligibility filter, senior mul removal
// v8.0: Product-keyed reviews, Preverjen kupec badge
// v7.9: CTA rename, max 3 upsells
// v7.6: Interaktivna qty tabela, radio krogci
// v7.5: Desktop layout slika|tekst, 2 taba, 1 produkt per tab
// v7.1: Supabase scoring engine
// v7.0: Supabase quiz_submissions + n8n webhook
// ================================================================

// ===== STATE =====
const S = {
  step: 0,              // 0=welcome, 1=Q2, 2=Q3, 3=Q4, 4=Q5, 5=Q6, 6=Q7, 7=email, 8=loading, 9=results
  name: '',
  ownerName: '',        // owner's first name (captured on welcome)
  gender: null,         // 'male'|'female'
  lifeStage: null,      // 'puppy'|'adult'|'senior'
  ageMonths: null,
  breed: null,          // string or null
  weightKg: null,
  adultWeightKg: null,
  bodyCondition: null,  // 1,3,4,5 (3=ideal) — user must select
  activity: null,       // 'low'|'normal'|'high'|'pro'
  eatingHabits: null,   // 'good'|'sometimes'|'veryPicky'
  allergens: [],
  healthConditions: [], // ['prebava','skin','joints']
  currentFood: null,    // 'briketi'|'mokra'|'barf'|'liofilizirano'|'zamrznjena'|'kuhamo'
  currentBrand: null,   // string — current food brand (Klaviyo remarketing)
  email: null,
  emailOptin: true
};

// ===== CDN IMAGES =====
const CDN = 'https://cdn.shopify.com/s/files/1/0303/4310/2509/files';
const CDN_SHOP = 'https://cdn.shopify.com/s/files/1/0303/4310/2509';
const QUIZ_IMAGES = {
  welcome:      `${CDN}/kviz-welcome1.png`,
  loading:      `${CDN}/kviz-loading1.png`,
  q2_puppy:     `${CDN}/kviz-q3-puppy1.png`,
  q2_adult:     `${CDN}/kviz-q4-bc3-idealen1.png`,
  q2_senior:    `${CDN}/kviz-q3-senior1.png`,
  q3_bc1:       `${CDN}/kviz-q4-bc1-presuh1.png`,
  q3_bc3:       `${CDN}/kviz-q4-bc3-idealen1.png`,
  q3_bc4:       `${CDN}/kviz-q4-bc4-debel1.png`,
  q3_bc5:       `${CDN}/kviz-q4-bc5-predebel1.png`,
  q4_low:       `${CDN}/kviz-q5-miren1.png`,
  q4_normal:    `${CDN}/kviz-q4-bc3-idealen1.png`,
  q4_high:      `${CDN}/kviz-q5-sportni1.png`,
  q4_pro:       `${CDN}/kviz-q5-pro-atlet1.png`,
  q5_good:      `${CDN}/kviz-q2-jedec1.png`,
  q5_sometimes: `${CDN}/kviz-q2-malo-izbircen1.png`,
  q5_veryPicky: `${CDN}/kviz-q2-izbircen1.png`,
};

// ===== SLOVENIAN POSSESSIVE HELPER =====
// "Max" → "Maxov", "Luna" → "Lunin", "Bella" → "Bellin"
function poss(name) {
  if (!name) return '';
  const n = name.trim();
  const last = n.slice(-1).toLowerCase();
  if (last === 'a') {
    // Female names ending in -a: Luna → Lunin, Bella → Bellin
    return n.slice(0, -1) + 'in';
  }
  if ('eiou'.includes(last)) {
    // Names ending in other vowels: rare, treat as-is + n
    return n + 'n';
  }
  // Male names ending in consonant: Max → Maxov, Rex → Rexov
  return n + 'ov';
}
// Accusative: "Max" → "Maxa", "Luna" → "Luno"
function acc(name) {
  if (!name) return '';
  const n = name.trim();
  const last = n.slice(-1).toLowerCase();
  if (last === 'a') return n.slice(0, -1) + 'o';
  if ('eiou'.includes(last)) return n;
  return n + 'a';
}

// idx: 0=welcome, 1=Q1(JAZ), 2=Q2, 3=Q3, 4=Q4, 5=Q5, 6=Q6, 7=Q7, 8=email, 9=loading, 10=results
// Q1 (belief) removed — owner name merged into Welcome
// New indices: 0=welcome, 1=Q2, 2=Q3, 3=Q4, 4=Q5, 5=Q6, 6=Q7, 7=email, 8=loading, 9=results
const SCREENS = ['scr-welcome','scr-q2','scr-q3','scr-q4','scr-q5','scr-q6','scr-q7','scr-email','scr-loading','scr-results'];

// Progress bar: 3 phases — MOJ PES (Q2-Q4), ANALIZA (Q5-Q7), TVOJ PLAN (Email)
// Indices: q2=1, q3=2, q4=3, q5=4, q6=5, q7=6, email=7
function renderProgressBar(stepIdx) {
  const phases = [
    { label: 'MOJ PES', screens: [1, 2, 3] },
    { label: 'ANALIZA', screens: [4, 5, 6] },
    { label: 'TVOJ PLAN', screens: [7] }
  ];
  let html = '';
  phases.forEach((p, i) => {
    const isActive = p.screens.includes(stepIdx);
    const isDone = stepIdx > Math.max(...p.screens);
    const dotCls = isDone ? 'done' : isActive ? 'active' : '';
    const lblCls = isDone ? 'done' : isActive ? 'active' : '';
    html += `<div class="pb-step"><span class="pb-label ${lblCls}">${p.label}</span><div class="pb-dot ${dotCls}"></div></div>`;
    if (i < phases.length - 1) {
      // Track between dots with fill progress
      let fillPct = 0;
      if (isDone) fillPct = 100;
      else if (isActive) {
        const pIdx = p.screens.indexOf(stepIdx);
        fillPct = ((pIdx + 1) / p.screens.length) * 100;
      }
      html += `<div class="pb-track"><div class="pb-track-fill" style="width:${fillPct}%"></div></div>`;
    }
  });
  // Map stepIdx to progress bar container ID
  const pbMap = {1:'q2',2:'q3',3:'q4',4:'q5',5:'q6',6:'q7',7:'email'};
  const el = document.getElementById('pb-' + (pbMap[stepIdx] || 'q1'));
  if (el) el.innerHTML = html;
  // Step counter — separate element below top-nav (not inside flex progress bar)
  const topNav = el && el.closest('.top-nav');
  let counter = topNav && topNav.nextElementSibling;
  if (!counter || !counter.classList.contains('pb-counter')) {
    counter = document.createElement('div');
    counter.className = 'pb-counter';
    counter.style.cssText = 'text-align:center;font-size:11px;color:var(--g400);margin:-12px 0 12px';
    if (topNav) topNav.after(counter);
  }
  if (counter) {
    if (stepIdx >= 1 && stepIdx <= 6) counter.textContent = 'Vpra\u0161anje ' + stepIdx + ' od 7';
    else if (stepIdx === 7) counter.textContent = 'Skoraj kon\u010dano \u2014 samo \u0161e email za tvoj plan!';
    else counter.textContent = '';
  }
}

// ===== PRODUCTS =====
const PRODUCTS = [
  { id:'adult-chicken', name:'Adult Chicken', short:'Piščanec', flavor:['Piščanec'], allergens:['Koruza','Riž','Piščanec'], stage:['adult'], fGroup:1, kcal:364, handle:'adult-chicken', img:CDN_SHOP+'/files/suha-hrana-za-pse-adult-chicken.jpg', variants:[{sku:'M3000',t:'900 g',p:13.60,g:900},{sku:'3006',t:'1.5 kg',p:18.50,g:1500},{sku:'3000',t:'5 kg',p:35.30,g:5000}] },
  { id:'adult-beef', name:'Adult Beef', short:'Govedina', flavor:['Govedina'], allergens:['Krompir','Govedina'], stage:['adult'], fGroup:1, kcal:362, handle:'adult-beef-potato', img:CDN_SHOP+'/files/suha-hrana-za-pse-adult-beef-1500g.jpg', variants:[{sku:'M3300',t:'900 g',p:15.20,g:900},{sku:'3301',t:'1.5 kg',p:21.70,g:1500},{sku:'3300',t:'5 kg',p:41.30,g:5000}] },
  { id:'adult-iberico', name:'Adult Iberico', short:'Iberico', flavor:['Iberico'], allergens:['Krompir','Iberico (svinjina)'], stage:['adult'], fGroup:2, kcal:355, handle:'adult-iberico-greens', img:CDN_SHOP+'/files/suha-hrana-za-pse-adult-iberico.jpg', variants:[{sku:'M3200',t:'900 g',p:15.20,g:900},{sku:'3201',t:'1.5 kg',p:21.70,g:1500},{sku:'3200',t:'5 kg',p:41.30,g:5000}] },
  { id:'adult-lamb', name:'Adult Lamb', short:'Jagnjetina', flavor:['Jagnjetina'], allergens:['Riž','Jagnjetina'], stage:['adult'], fGroup:2, kcal:352, handle:'adult-lamb-rice', img:CDN_SHOP+'/files/suha-hrana-za-pse-adult-lamb.jpg', variants:[{sku:'M2009',t:'900 g',p:16.30,g:900},{sku:'3013',t:'1.5 kg',p:22.80,g:1500},{sku:'2009',t:'5 kg',p:44.80,g:5000}] },
  { id:'puppy-chicken', name:'Puppy Chicken', short:'Piščanec (mladič)', flavor:['Piščanec'], allergens:['Riž','Piščanec'], stage:['puppy'], fGroup:1, kcal:364, handle:'puppy-chicken', img:CDN_SHOP+'/files/suha-hrana-za-pse-puppy-chicken.jpg', variants:[{sku:'M3001',t:'900 g',p:14.70,g:900},{sku:'3009',t:'1.5 kg',p:19.60,g:1500},{sku:'3001',t:'5 kg',p:38.10,g:5000}] },
  { id:'vet-senior', name:'Vetactive Senior', short:'Senior', flavor:['Piščanec'], allergens:['Riž','Piščanec'], stage:['senior'], fGroup:1, kcal:292, handle:'vetactive-senior', img:CDN_SHOP+'/files/vetactive-suha-hrana-pse-senior-chicken.jpg', variants:[{sku:'9211',t:'1.5 kg',p:21.50,g:1500},{sku:'9210',t:'5 kg',p:37.90,g:5000}], special:'senior' },
  { id:'vet-light', name:'Vetactive Light', short:'Light', flavor:['Piščanec'], allergens:['Riž','Piščanec'], stage:['adult'], fGroup:2, kcal:275, handle:'vetactive-light', img:CDN_SHOP+'/files/vetactive-suha-hrana-pse-light-chicken.jpg', variants:[{sku:'9201',t:'1.5 kg',p:21.70,g:1500},{sku:'9200',t:'5 kg',p:41.20,g:5000}], special:'light' },
  { id:'vet-sensitive', name:'Vetactive Sensitive', short:'Sensitive', flavor:['Puran'], allergens:['Riž','Puran'], stage:['adult'], fGroup:1, kcal:300, handle:'vetactive-sensitive', img:CDN_SHOP+'/files/vetactive-suha-hrana-pse-sensitive-turkey.jpg', variants:[{sku:'9241',t:'1.5 kg',p:22.80,g:1500},{sku:'9240',t:'5 kg',p:44.90,g:5000}], special:'sensitive' },
  { id:'vet-hypo', name:'Vetactive Hypoallergenic', short:'Hypoallergenic', flavor:['Iberico'], allergens:['Krompir','Iberico (svinjina)'], stage:['adult'], fGroup:1, kcal:300, handle:'vetactive-hypoallergenic', img:CDN_SHOP+'/files/vetactive-suha-hrana-pse-hypo-iberico.jpg', variants:[{sku:'9221',t:'1.5 kg',p:22.80,g:1500},{sku:'9220',t:'5 kg',p:44.90,g:5000}], special:'hypoallergenic' }
];

// ===== MENU (mokra hrana) =====
const MENU = [
  { id:'menu-chicken', name:'MENU Chicken', short:'Piščanec', flavor:['Piščanec'], allergens:['Riž','Piščanec','Riba'], stage:['adult'], kcal:178.1, handle:'menu-chicken', img:CDN_SHOP+'/products/mokra-hrana-pse-375g-chicken_1.jpg', sizes:[{t:'90g',g:90,p12:18.30},{t:'185g',g:185,p12:26.70},{t:'375g',g:375,p1:3.80,p12:41.10}] },
  { id:'menu-fish', name:'MENU Fish', short:'Riba', flavor:['Riba'], allergens:['Krompir','Riba'], stage:['adult'], kcal:162.6, handle:'menu-fish', img:CDN_SHOP+'/products/mokra-hrana-pse-375g-pure-fish_1.jpg', sizes:[{t:'90g',g:90,p12:18.30},{t:'185g',g:185,p12:26.70},{t:'375g',g:375,p1:3.80,p12:41.10}] },
  { id:'menu-turkey-salmon', name:'MENU Turkey+Salmon', short:'Puran+Losos', flavor:['Puran','Losos'], allergens:['Krompir','Puran','Riba'], stage:['adult'], kcal:159.1, handle:'menu-turkey-salmon', img:CDN_SHOP+'/products/mokra-hrana-pse-375g-turkey-salmon-1.jpg', sizes:[{t:'90g',g:90,p12:18.30},{t:'185g',g:185,p12:26.70},{t:'375g',g:375,p1:3.80,p12:41.10}] },
  { id:'menu-fish-chicken', name:'MENU Fish+Chicken', short:'Riba+Piščanec', flavor:['Riba','Piščanec'], allergens:['Krompir','Piščanec','Riba'], stage:['adult'], kcal:157.0, handle:'menu-fish-chicken', img:CDN_SHOP+'/products/mokra-hrana-pse-375g-fish-chicken_1.jpg', sizes:[{t:'90g',g:90,p12:18.30},{t:'185g',g:185,p12:26.70},{t:'375g',g:375,p1:3.80,p12:41.10}] },
  { id:'menu-beef-chicken', name:'MENU Beef+Chicken', short:'Govedina+Piščanec', flavor:['Govedina','Piščanec'], allergens:['Krompir','Piščanec','Govedina'], stage:['adult'], kcal:158.4, handle:'menu-beef-chicken', img:CDN_SHOP+'/products/mokra-hrana-pse-375g-beef-chicken_1.jpg', sizes:[{t:'90g',g:90,p12:18.30},{t:'185g',g:185,p12:26.70},{t:'375g',g:375,p1:3.80,p12:41.10}] },
  { id:'menu-duck-turkey', name:'MENU Duck+Turkey', short:'Raca+Puran', flavor:['Raca','Puran'], allergens:['Puran','Račka'], stage:['adult'], kcal:168.0, handle:'menu-duck-turkey', img:CDN_SHOP+'/products/mokra-hrana-pse-375g-duck-turkey_1.jpg', sizes:[{t:'90g',g:90,p12:18.30},{t:'185g',g:185,p12:26.70},{t:'375g',g:375,p1:3.80,p12:41.10}] },
  { id:'menu-iberico-turkey', name:'MENU Iberico+Turkey', short:'Iberico+Puran', flavor:['Iberico','Puran'], allergens:['Krompir','Iberico (svinjina)','Puran'], stage:['adult'], kcal:157.6, handle:'menu-iberico-turkey', img:CDN_SHOP+'/products/mokra-hrana-pse-375g-iberico-turkey_1.jpg', sizes:[{t:'90g',g:90,p12:18.30},{t:'185g',g:185,p12:26.70},{t:'375g',g:375,p1:3.80,p12:41.10}] },
  { id:'menu-puppy', name:'MENU Puppy Chicken', short:'Piščanec (mladič)', flavor:['Piščanec'], allergens:['Piščanec'], stage:['puppy'], kcal:166.2, handle:'menu-puppy-chicken', img:CDN_SHOP+'/products/mokra-hrana-pse-375g-puppy-chicken_1.jpg', sizes:[{t:'90g',g:90,p12:18.30},{t:'185g',g:185,p12:26.70},{t:'375g',g:375,p1:3.80,p12:41.10}] }
];

// ===== QUANTITY DISCOUNT TABLES =====
var DRY_QTY = [{q:1,d:0},{q:2,d:0.10},{q:3,d:0.20},{q:4,d:0.23},{q:6,d:0.28}];
var WET_QTY = [{q:1,d:0},{q:2,d:0.11},{q:3,d:0.11},{q:4,d:0.11},{q:6,d:0.11}];

// ===== UPSELLS (nega + priboljški) =====
// Vrstni red = PRIORITETA: zdravje/nega → Stars → puppy/presuh priboljški
// .slice(0,3) v renderResults vzame prve 3 — zato zdravje MORA biti pred Stars
const UPSELLS = [
  // --- Prioriteta 1: zdravje & nega ---
  { id:'oralclean', name:'OralClean+Care Classic', handle:'oralclean-care-classic-gel', price:35.90, trigger:['senior','default'], desc:'Zobni kamen stran brez narkoze in stresa. Vidna razlika v nekaj tednih, sve\u017e dah pa \u017ee v dneh.', allergens:[], img:CDN_SHOP+'/files/OCC_Classic_Gel_EN.jpg' },
  { id:'skincare', name:'Skin Care', handle:'skincare', price:19.40, trigger:['skin'], desc:'Celjenje ran in sijaj dlake v 4–6 tednih', allergens:[], img:CDN_SHOP+'/files/care-dog-cat-skincare.jpg' },
  { id:'fitbits-detox', name:'Fit Bits Detox', handle:'fit-bits-detox', price:8.60, trigger:['skin','prebava'], desc:'Čisti telo od znotraj – naravna zelišča za pse po alergijah, antibiotikih in kožnih težavah', allergens:['Krompir','Piščanec'], img:CDN_SHOP+'/files/priboljski-psi-Fit-Bits-Detox-1.jpg' },
  { id:'fitbits-mobility', name:'Fit Bits Mobility', handle:'fit-bits-mobility', price:8.60, trigger:['senior','joints'], desc:'Mehkejša hoja in manj togosti – glukozamin in hondroitin za gibljive sklepe', allergens:['Krompir','Piščanec'], img:CDN_SHOP+'/files/priboljski-psi-Fit-Bits-Mobility-1.jpg' },
  { id:'fitbits-relax', name:'Fit Bits Relax', handle:'fit-bits-relax', price:8.60, trigger:['prebava'], desc:'Za pomiritev ob stresu in tesnobi – idealno za potovanja, obisk veterinarja in živčne pse', allergens:['Krompir','Piščanec'], img:CDN_SHOP+'/files/priboljski-psi-Fit-Bits-Relax-1.jpg' },
  { id:'fitbits-protect', name:'Fit Bits Protect', handle:'fit-bits-protect', price:8.60, trigger:['senior'], desc:'Podpira obrambo kože tvojega psa pred klopi in bolhami', allergens:['Krompir','Piščanec'], img:CDN_SHOP+'/files/priboljski-psi-Fit-Bits-Protect-1.jpg' },
  // --- Prioriteta 2: Stars priboljški ---
  { id:'iberico-stars', name:'Iberico Stars', handle:'iberico-stars-185g', price:6.60, trigger:['picky','aktiven','default'], desc:'Monoproteinski priboljšek iz Iberico svinjine – samo ena vrsta mesa, brez žit, brez dodanega sladkorja', allergens:['Krompir','Iberico (svinjina)'], img:CDN_SHOP+'/files/priboljski-stars-iberico2.jpg' },
  { id:'salmon-stars', name:'Salmon Stars', handle:'salmon-stars-185g', price:6.60, trigger:['picky','aktiven','default'], desc:'Monoproteinski priboljšek iz lososa za izbirneže in alergike', allergens:['Krompir','Riba'], img:CDN_SHOP+'/files/priboljski-stars-salmon2_cf584452-3d0e-4977-b627-aaddd370132a.jpg' },
  { id:'stars-turkey', name:'Stars Turkey', handle:'stars-turkey-185g', price:6.60, trigger:['picky','aktiven','default'], desc:'Monoproteinski priboljšek iz purana – čista nagrada, lahka za prebavo', allergens:['Krompir','Puran'], img:CDN_SHOP+'/files/priboljski-stars-turkey2_ff57ee35-805a-4cfe-b739-8201e47fe546.jpg' },
  // --- Prioriteta 3: puppy/presuh/aktiven priboljški ---
  { id:'click-bits', name:'Click-Bits Chicken+Lamb', handle:'click-bits-chicken-lamb-1', price:4.30, trigger:['default','puppy','presuh'], desc:'Majhni mehki priboljški – idealni za click trening in hitro nagrajevanje', allergens:['Riž','Piščanec','Jagnjetina'], img:CDN_SHOP+'/files/priboljski-za-pse-clickbits-chicken-lamb2.jpg' },
  { id:'fitsticks-lamb', name:'Fit-Sticks Chicken+Lamb', handle:'fit-sticks-chicken-lamb', price:7.50, trigger:['presuh','puppy'], desc:'Slastna palčka za nagrado – deli na kose po svoji meri', allergens:['Riž','Piščanec','Jagnjetina'], img:CDN_SHOP+'/products/priboljski-za-pse-fitsticks-chicken-lamb.jpg' },
  { id:'fitsticks-rabbit', name:'Fit-Sticks Chicken+Rabbit', handle:'fit-sticks-chicken-rabbit', price:7.50, trigger:['aktiven','presuh','puppy'], desc:'Zajčje meso + piščanec – visoko beljakovinska palčka za aktivne pse', allergens:['Riž','Piščanec','Zajec'], img:CDN_SHOP+'/products/priboljski-za-pse-fitsticks-chicken-rabbit.jpg' }
];

// ===== FALLBACK SCORES (zrcali Supabase quiz_scoring_rules — za ko Supabase ne odgovori) =====
const FALLBACK_SCORES = {
  base: {
    'Adult Chicken':85, 'Adult Beef':80, 'Adult Iberico':80, 'Adult Lamb':75,
    'Puppy Chicken':90, 'Vetactive Senior':50, 'Vetactive Light':50,
    'Vetactive Sensitive':50, 'Vetactive Hypoallergenic':50
  },
  eatingHabits: {
    veryPicky: { 'Adult Iberico':30, 'Adult Lamb':25 },
    sometimes: { 'Adult Iberico':15, 'Adult Lamb':15 }
  },
  currentFood: {
    briketi: { 'Adult Chicken':20 },
    barf:    { 'Adult Chicken':-50, 'Adult Beef':30, 'Adult Lamb':20 },
    liofilizirano: { 'Adult Chicken':-50, 'Adult Beef':30, 'Adult Lamb':20 },
    polsuha: {},
    kuhamo:  { 'Adult Lamb':15, 'Adult Beef':10 },
    mokra:   { 'Adult Iberico':10 }
  },
  health: {
    prebava: { 'Vetactive Sensitive':200 }
  },
  bodyCondition: {
    4: { 'Vetactive Light':150 },
    5: { 'Vetactive Light':300 }
  },
  allergy: {},
  menuBase: {
    'MENU Turkey+Salmon':80, 'MENU Duck+Turkey':75, 'MENU Beef+Chicken':75,
    'MENU Chicken':70, 'MENU Iberico+Turkey':70, 'MENU Fish':65,
    'MENU Fish+Chicken':60, 'MENU Puppy Chicken':90
  },
  menuHealth: {
    prebava: { 'MENU Turkey+Salmon':50 },
    skin: { 'MENU Fish':60, 'MENU Fish+Chicken':40 },
    joints: { 'MENU Fish':40, 'MENU Fish+Chicken':25 }
  }
};

// ===== FEEDING TABLES (let — can be overwritten by quiz-feeding-tables.json) =====
let FG1 = [{w:1,d:30},{w:2,d:40},{w:3,d:55},{w:4,d:70},{w:5,d:85},{w:7.5,d:115},{w:10,d:150},{w:12.5,d:165},{w:15,d:190},{w:20,d:250},{w:25,d:300},{w:30,d:325},{w:40,d:425},{w:60,d:600},{w:80,d:750}];
let FG2 = [{w:1,d:35},{w:2,d:45},{w:3,d:60},{w:4,d:75},{w:5,d:90},{w:7.5,d:120},{w:10,d:160},{w:12.5,d:175},{w:15,d:200},{w:20,d:260},{w:25,d:315},{w:30,d:340},{w:40,d:445},{w:60,d:630},{w:80,d:790}];

let PUPPY={"1":{"2":25,"4":30,"6":40,"8":30,"10":30,"12":30},"2.5":{"2":50,"4":55,"6":60,"8":55,"10":55,"12":50},"3":{"2":55,"4":60,"6":75,"8":65,"10":65,"12":65},"5":{"2":85,"4":105,"6":110,"8":100,"10":95,"12":85},"7.5":{"2":115,"4":145,"6":150,"8":140,"10":135,"12":115},"10":{"2":130,"4":160,"6":175,"8":165,"10":160,"12":150},"12.5":{"2":145,"4":180,"6":195,"8":185,"10":180,"12":165},"15":{"2":160,"4":215,"6":220,"8":215,"10":215,"12":190},"20":{"2":205,"4":260,"6":275,"8":270,"10":270,"12":250},"25":{"2":235,"4":300,"6":320,"8":320,"10":320,"12":300},"30":{"2":270,"4":360,"6":370,"8":370,"10":365,"12":325},"40":{"2":320,"4":420,"6":440,"8":500,"10":455,"12":425},"60":{"2":370,"4":580,"6":605,"8":650,"10":630,"12":600},"80":{"2":410,"4":710,"6":750,"8":820,"10":810,"12":750}};
let PW=[1,2.5,3,5,7.5,10,12.5,15,20,25,30,40,60,80];

// ===== WET FEEDING TABLES (Adult) =====
// Wet-only g/day (identično za obe feeding skupini)
let WET=[{w:1,d:46},{w:2,d:92},{w:3,d:138},{w:4,d:184},{w:5,d:185},{w:7.5,d:278},{w:10,d:310},{w:12.5,d:388},{w:15,d:465},{w:20,d:520},{w:25,d:650},{w:30,d:780},{w:40,d:880},{w:60,d:1320},{w:80,d:1760}];
// Combo dry g/day — razlika med skupinama
let CD1=[{w:1,d:15},{w:2,d:20},{w:3,d:28},{w:4,d:35},{w:5,d:43},{w:7.5,d:58},{w:10,d:75},{w:12.5,d:83},{w:15,d:95},{w:20,d:125},{w:25,d:150},{w:30,d:163},{w:40,d:213},{w:60,d:300},{w:80,d:375}];
let CD2=[{w:1,d:18},{w:2,d:23},{w:3,d:30},{w:4,d:38},{w:5,d:45},{w:7.5,d:60},{w:10,d:80},{w:12.5,d:88},{w:15,d:100},{w:20,d:130},{w:25,d:158},{w:30,d:170},{w:40,d:223},{w:60,d:315},{w:80,d:395}];
// Combo wet g/day (identično za obe skupini)
let CWET=[{w:1,d:23},{w:2,d:46},{w:3,d:69},{w:4,d:92},{w:5,d:93},{w:7.5,d:139},{w:10,d:155},{w:12.5,d:194},{w:15,d:233},{w:20,d:260},{w:25,d:325},{w:30,d:390},{w:40,d:440},{w:60,d:660},{w:80,d:880}];

// ===== WET FEEDING TABLES (Puppy) =====
let PUPPY_WET={"1":{"2":35,"4":45,"6":58,"8":50,"10":50,"12":50},"2.5":{"2":88,"4":113,"6":145,"8":125,"10":125,"12":125},"3":{"2":105,"4":135,"6":174,"8":150,"10":150,"12":150},"5":{"2":175,"4":225,"6":290,"8":250,"10":250,"12":250},"7.5":{"2":263,"4":338,"6":435,"8":375,"10":375,"12":375},"10":{"2":200,"4":380,"6":420,"8":400,"10":400,"12":400},"12.5":{"2":250,"4":475,"6":525,"8":500,"10":500,"12":500},"15":{"2":300,"4":570,"6":630,"8":600,"10":600,"12":600},"20":{"2":340,"4":640,"6":680,"8":760,"10":680,"12":680},"25":{"2":425,"4":800,"6":850,"8":950,"10":850,"12":850},"30":{"2":510,"4":960,"6":1020,"8":1140,"10":1020,"12":1020},"40":{"2":520,"4":1000,"6":1160,"8":1280,"10":1360,"12":1200},"60":{"2":780,"4":1500,"6":1740,"8":1920,"10":2040,"12":1800},"80":{"2":1040,"4":2000,"6":2320,"8":2560,"10":2720,"12":2400}};
let PUPPY_CD={"1":{"2":13,"4":15,"6":20,"8":15,"10":15,"12":15},"2.5":{"2":25,"4":28,"6":30,"8":28,"10":28,"12":25},"3":{"2":28,"4":30,"6":38,"8":33,"10":33,"12":33},"5":{"2":43,"4":53,"6":55,"8":50,"10":48,"12":43},"7.5":{"2":58,"4":73,"6":75,"8":70,"10":68,"12":58},"10":{"2":65,"4":80,"6":88,"8":83,"10":80,"12":75},"12.5":{"2":73,"4":90,"6":98,"8":93,"10":90,"12":83},"15":{"2":80,"4":108,"6":110,"8":108,"10":108,"12":95},"20":{"2":103,"4":130,"6":138,"8":135,"10":135,"12":125},"25":{"2":118,"4":150,"6":160,"8":160,"10":160,"12":150},"30":{"2":135,"4":180,"6":185,"8":185,"10":183,"12":163},"40":{"2":160,"4":210,"6":220,"8":250,"10":228,"12":213},"60":{"2":185,"4":290,"6":303,"8":325,"10":315,"12":300},"80":{"2":205,"4":355,"6":375,"8":410,"10":405,"12":375}};
let PUPPY_CW={"1":{"2":18,"4":23,"6":29,"8":25,"10":25,"12":25},"2.5":{"2":44,"4":57,"6":73,"8":63,"10":63,"12":63},"3":{"2":53,"4":68,"6":87,"8":75,"10":75,"12":75},"5":{"2":88,"4":113,"6":145,"8":125,"10":125,"12":125},"7.5":{"2":132,"4":169,"6":218,"8":188,"10":188,"12":188},"10":{"2":100,"4":190,"6":210,"8":200,"10":200,"12":200},"12.5":{"2":125,"4":238,"6":263,"8":250,"10":250,"12":250},"15":{"2":150,"4":285,"6":315,"8":300,"10":300,"12":300},"20":{"2":170,"4":320,"6":340,"8":380,"10":340,"12":340},"25":{"2":213,"4":400,"6":425,"8":475,"10":425,"12":425},"30":{"2":255,"4":480,"6":510,"8":570,"10":510,"12":510},"40":{"2":260,"4":500,"6":580,"8":640,"10":680,"12":600},"60":{"2":390,"4":750,"6":870,"8":960,"10":1020,"12":900},"80":{"2":520,"4":1000,"6":1160,"8":1280,"10":1360,"12":1200}};

// ===== QUIZ DATA FETCH (Supabase + JSON) =====
let QUIZ_DATA = {
  rules: [],
  productConfig: [],
  feedingTables: null,
  dataSource: 'fallback',
  loaded: false
};

const SUPABASE_URL = 'https://nvwzltbykmfjkhdmkjlg.supabase.co';
const SUPABASE_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im52d3psdGJ5a21mamtoZG1ramxnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM2NDQxODQsImV4cCI6MjA3OTIyMDE4NH0.CLcXHCrT0VkCQPiDpHmCV58DG79SNDSePq7SlzItXfU';

async function fetchQuizData() {
  var controller = new AbortController();
  var timeout = setTimeout(function() { controller.abort(); }, 2000);

  try {
    var headers = {
      'apikey': SUPABASE_ANON,
      'Authorization': 'Bearer ' + SUPABASE_ANON
    };

    var results = await Promise.all([
      fetch(SUPABASE_URL + '/rest/v1/quiz_scoring_rules?aktivno=eq.true&select=*&order=id', {
        headers: headers, signal: controller.signal
      }),
      fetch(SUPABASE_URL + '/rest/v1/quiz_product_config?enabled=eq.true&select=*', {
        headers: headers, signal: controller.signal
      }),
      fetch('quiz-feeding-tables.json', { signal: controller.signal }).catch(function() { return null; }),
      fetch(SUPABASE_URL + '/rest/v1/social_products?select=handle,kcal_per_100g,variants,featured_image&available=eq.true', {
        headers: headers, signal: controller.signal
      }).catch(function() { return null; })
    ]);

    clearTimeout(timeout);

    var rulesRes = results[0];
    var configRes = results[1];
    var feedingRes = results[2];
    var kcalRes = results[3];

    if (rulesRes.ok && configRes.ok) {
      QUIZ_DATA.rules = await rulesRes.json();
      QUIZ_DATA.productConfig = await configRes.json();
      QUIZ_DATA.dataSource = 'supabase';
    }

    if (feedingRes && feedingRes.ok) {
      QUIZ_DATA.feedingTables = await feedingRes.json();
      applyFeedingTables(QUIZ_DATA.feedingTables);
    }

    // Posodobi PRODUCTS + MENU kcal + cene + slike iz Supabase (dinamično — sledi Shopify)
    if (kcalRes && kcalRes.ok) {
      var spData = await kcalRes.json();
      var priceUpdates = 0;
      var imageUpdates = 0;

      spData.forEach(function(row) {
        var variants = row.variants;
        if (typeof variants === 'string') { try { variants = JSON.parse(variants); } catch(e) { variants = null; } }

        // --- Kcal + image sync ---
        var p = PRODUCTS.find(function(p) { return p.handle === row.handle; });
        if (p) {
          if (row.kcal_per_100g) p.kcal = Math.round(row.kcal_per_100g);
          if (row.featured_image) { p.img = row.featured_image; imageUpdates++; }
        }
        var m = MENU.find(function(m) { return m.handle === row.handle; });
        if (m) {
          if (row.kcal_per_100g) m.kcal = parseFloat(row.kcal_per_100g);
          if (row.featured_image) { m.img = row.featured_image; imageUpdates++; }
        }

        // --- Upsells: image sync (price sync below requires variants) ---
        var u = UPSELLS.find(function(u) { return u.handle === row.handle; });
        if (u && row.featured_image) { u.img = row.featured_image; imageUpdates++; }

        if (!variants || !variants.length) return;

        // --- Price sync: suha hrana (PRODUCTS) ---
        if (p) {
          variants.forEach(function(sv) {
            var v = p.variants.find(function(v) { return v.sku === sv.sku; });
            if (v && sv.price != null) { v.p = parseFloat(sv.price); priceUpdates++; }
          });
        }

        // --- Price sync: mokra hrana (MENU) ---
        if (m) {
          variants.forEach(function(sv) {
            var sku = sv.sku || '';
            var price = parseFloat(sv.price);
            if (isNaN(price)) return;
            var is12 = sku.indexOf('-12') !== -1;
            if (sku.charAt(0) === 'S') {
              if (is12 && m.sizes[0]) { m.sizes[0].p12 = price; priceUpdates++; }
            } else if (sku.charAt(0) === 'M') {
              if (is12 && m.sizes[1]) { m.sizes[1].p12 = price; priceUpdates++; }
            } else {
              if (is12 && m.sizes[2]) { m.sizes[2].p12 = price; priceUpdates++; }
              else if (!is12 && m.sizes[2]) { m.sizes[2].p1 = price; priceUpdates++; }
            }
          });
        }

        // --- Price sync: upselli ---
        if (u && variants[0] && variants[0].price != null) {
          u.price = parseFloat(variants[0].price);
          priceUpdates++;
        }
      });

      console.log('Price sync: ' + priceUpdates + ' prices, Image sync: ' + imageUpdates + ' images');
    }

    QUIZ_DATA.loaded = true;
    console.log('Quiz data loaded:', QUIZ_DATA.dataSource,
      QUIZ_DATA.rules.length + ' rules,',
      QUIZ_DATA.productConfig.length + ' products');

  } catch (err) {
    clearTimeout(timeout);
    QUIZ_DATA.loaded = true;
    console.warn('fetchQuizData fallback:', err.message);
  }
}

// ===== STOCK CHECK (Shopify realtime) =====
var STOCK_MAP = {}; // handle → [{variantId, title, available}, ...]

function collectHandles(res) {
  var handles = {};
  ['dry','wet','combo'].forEach(function(mode) {
    var md = res.byMode[mode];
    if (!md) return;
    md.products.forEach(function(p) { handles[p.handle] = true; });
    if (md.menuPick) handles[md.menuPick.handle] = true;
  });
  res.upsells.forEach(function(u) { handles[u.handle] = true; });
  return Object.keys(handles);
}

async function fetchStock(handles) {
  var controller = new AbortController();
  var timeout = setTimeout(function() { controller.abort(); }, 3000);
  try {
    var fetches = handles.map(function(h) {
      return fetch('https://platinum.si/products/' + h + '.js', { signal: controller.signal })
        .then(function(r) { return r.ok ? r.json() : null; })
        .catch(function() { return null; });
    });
    var results = await Promise.all(fetches);
    clearTimeout(timeout);
    var map = {};
    results.forEach(function(prod, i) {
      if (!prod || !prod.variants) return;
      map[handles[i]] = prod.variants.map(function(v) {
        return { id: v.id, title: v.title || '', available: !!v.available };
      });
    });
    return map;
  } catch (e) {
    clearTimeout(timeout);
    console.warn('fetchStock fallback:', e.message);
    return {};
  }
}

function applyStock(res, stockMap) {
  if (!stockMap || Object.keys(stockMap).length === 0) return;
  STOCK_MAP = stockMap;

  // Apply to all 3 modes
  ['dry','wet','combo'].forEach(function(mode) {
    var md = res.byMode[mode];
    if (!md) return;

    // Dry products — match variants by size label
    md.products.forEach(function(p) {
      var sv = stockMap[p.handle];
      if (!sv) return;
      var allOos = true;
      p.costs.forEach(function(c) {
        // Match: variant title equals or starts/ends with cost label
        // Use word-boundary match to avoid "5 kg" matching "1.5 kg"
        var match = sv.find(function(v) {
          var t = v.title.trim();
          if (t === c.t) return true;  // exact match
          // Word-boundary: check char before match is not alphanumeric/dot
          var pos = t.indexOf(c.t);
          if (pos === -1) return false;
          if (pos === 0) return true;  // starts with label
          var charBefore = t.charAt(pos - 1);
          return charBefore === ' ' || charBefore === '(' || charBefore === '/';
        });
        c.available = match ? match.available : true; // Default true if no match
        c.variantId = match ? match.id : null;
        if (c.available) allOos = false;
      });
      p.outOfStock = allOos;
    });

    // Menu (wet) — match sizes
    if (md.menuPick) {
      var mv = stockMap[md.menuPick.handle];
      if (mv) {
        var allMenuOos = true;
        md.menuPick.sizes.forEach(function(sz) {
          // MENU variants are "12× 90g", "12× 185g", "12× 375g" or similar
          var match = mv.find(function(v) {
            return v.title.indexOf(sz.t) !== -1 || v.title.indexOf('12') !== -1 && v.title.indexOf(String(sz.g)) !== -1;
          });
          sz.available = match ? match.available : true;
          sz.variantId = match ? match.id : null;
          if (sz.available) allMenuOos = false;
        });
        md.menuPick.outOfStock = allMenuOos;
      }
    }
  });

  // Upsells
  res.upsells.forEach(function(u) {
    var uv = stockMap[u.handle];
    if (!uv) return;
    u.outOfStock = !uv.some(function(v) { return v.available; });
  });
  // Remove OOS upsells (less noise)
  res.upsells = res.upsells.filter(function(u) { return !u.outOfStock; });
}

function applyFeedingTables(ft) {
  if (!ft) return;
  if (ft.adult) {
    if (ft.adult.dry) {
      if (ft.adult.dry.fg1) FG1 = ft.adult.dry.fg1;
      if (ft.adult.dry.fg2) FG2 = ft.adult.dry.fg2;
    }
    if (ft.adult.wet) WET = ft.adult.wet;
    if (ft.adult.combo_dry) {
      if (ft.adult.combo_dry.cd1) CD1 = ft.adult.combo_dry.cd1;
      if (ft.adult.combo_dry.cd2) CD2 = ft.adult.combo_dry.cd2;
    }
    if (ft.adult.combo_wet) CWET = ft.adult.combo_wet;
  }
  if (ft.puppy) {
    if (ft.puppy.weights) PW = ft.puppy.weights;
    if (ft.puppy.dry) PUPPY = ft.puppy.dry;
    if (ft.puppy.wet) PUPPY_WET = ft.puppy.wet;
    if (ft.puppy.combo_dry) PUPPY_CD = ft.puppy.combo_dry;
    if (ft.puppy.combo_wet) PUPPY_CW = ft.puppy.combo_wet;
  }
}

// Auto-fetch on page load
fetchQuizData();

// ===== SOCIAL PROOF =====
// Review pools — pravi reviewi iz Supabase, ključ = product ID, prej/potem fokus
const QUOTES_DRY = {
  'adult-chicken': [
    { text: 'Naš Teddy pasme čivava je zelo neješč in izbirčen, te briketke pa obožuje. Končno smo našli kvalitetno hrano.', author: 'Ditka K.' },
    { text: 'Nima nobenih prebavnih ali drugih težav in tudi dlaka ji manj izpada kot pri drugi znamki hrane.', author: 'Aleša D.' },
    { text: 'Naš pes jo je že 9 let. Edini piščanec, ki mu ne povzroča kakšnih alergij ali srbečice.', author: 'Mojca P.' },
    { text: 'Imamo izbirčnega beagla – pri Platinumu, po enem letu, še vedno komaj čaka svoj obrok.', author: 'Katja B.' },
    { text: 'Hrana je vrhunska. Ne menjamo več. Prebava je super, počutje kužkov vidno izboljšano, kožušček svetleč.', author: 'Nastja K.' },
  ],
  'adult-beef': [
    { text: 'Prva hrana po dolgem času, ki naši labradorki ne povzroča nobenih prebavnih težav. Zvesti kupci že skoraj eno leto.', author: 'Anja' },
    { text: 'Od kar koristimo samo Platinum, smo se znebili vseh alergij – bile so tako hude, da smo morali k veterinarju po injekcije.', author: 'Špela Š.' },
    { text: 'Ran je alergičen na piščančje meso in mu ta govedina zelo ugaja.', author: 'Mojca Č.' },
    { text: 'Na sprehodih večkrat slišimo: "Vaš je pa še mlad psiček?" Težko razložimo, da bo naš Troy star 13 let!', author: 'Troy, labrador' },
    { text: 'Mojemu 11-letniku je hrana tako okusna, da jo uživa tudi samostojno. Koščki so ravno prav veliki in mehki.', author: 'Jure B.' },
  ],
  'adult-iberico': [
    { text: 'Pred tem zamenjali 10 vrst hrane. Platinum je prva po kateri psica nima težav s prebavo in težo.', author: 'Rok B.' },
    { text: 'Dokler nisem poizkusil Platinum Iberico, sem jedel samo kuhano in mokro hrano. Vse moje težave so preteklost.', author: 'Dunja L.' },
    { text: 'Te briketi so res najboljši za moji dve izbirčni kosmati riti. Ne povzročajo prebavnih težav, kisline ali driske.', author: 'Tamara D.' },
    { text: 'Vsi prejšnji briketi so tako smrdeli – po Platinumu pa vonj iz gobčka ni več neprijeten.', author: 'Rebeka T.' },
    { text: 'Hrana diši, je kompaktna, vsi trije kužki jo z veseljem pojedo – dva zelo izbirčna.', author: 'Sarah K.' },
  ],
  'adult-lamb': [
    { text: 'Po dolgem času iskanja za mojega francoza – toplo priporočam vsem, ki imajo kužke z alergijami.', author: 'Sabina Ž.' },
    { text: 'Prebava se je pri moji Bostonki uredila, nima več vetrov.', author: 'Vesna E.' },
    { text: 'Po hrani jima manj izpada dlaka, tudi praskanje se je izboljšalo.', author: 'Dunja K.' },
    { text: 'Uporabljamo že več kot leto dni. Lepa dlaka in urejena prebava.', author: 'Tjaša O.' },
    { text: 'Naši psi imajo po njej lepe zobe, kvalitetno dlako, so v top kondiciji. Kakec je super.', author: 'Barbara K.' },
  ],
  'puppy-chicken': [
    { text: 'Manj kakca in nič driske. Prav tako se ne praska več.', author: 'Rok K.' },
    { text: 'Kužika zelo rada je te brikete – čvrsti kakci. Ni več težav z drisko.', author: 'Špela M.' },
    { text: 'Iz Prinsa smo zamenjali na Platinum in je očitna razlika v dlaki. Naš kuži jo obožuje!', author: 'Estera E.' },
    { text: 'Prej smo imeli kar nekaj težav s prebavo in smo probali kar nekaj briketov. Stanje se je popravilo.', author: 'Mirnes M.' },
    { text: 'Moj pekinezer je zelo izbirčen, do zdaj ni jedel nobene brikete – zdaj sva veseli, da imava vaše.', author: 'Slavica S.' },
  ],
  'vet-senior': [
    { text: 'Platinum hrana je edina, ki jo moj Remi lahko uživa brez težav s prebavo. Za starejše pse naravnost odlična.', author: 'Tamara Š.' },
    { text: 'Vedno znova se vračamo k Platinum – Rocco ima lep kožuh in primerno blato.', author: 'Marta M.' },
    { text: 'Naša seniorka jih naravnost obožuje in tudi blato je kompaktno.', author: 'Nina B.' },
    { text: 'Hrana je vrhunska. Ne menjamo več. Prebava je super, počutje kužkov vidno izboljšano, kožušček svetleč.', author: 'Nastja K.' },
    { text: 'Priporočamo – že 8 let. Poskušali smo tudi hrano drugih proizvajalcev, pa psu ni ustrezala.', author: 'Mojca P.' },
  ],
  'vet-light': [
    { text: 'Ker ima preveč kilogramov, smo prešli na Light – že po nekaj tednih opaža večja živahnost in aktivnost.', author: 'Silvester F.' },
    { text: 'Po večih letih iskanja smo končno našli – alergija na pršice, občutljiv želodec... verjamem, da sledi izguba teže.', author: 'Teja Š.' },
    { text: 'Lara, 12 let, prej ni marala briketov. Vaše brikete z užitkom poje, ni več toliko pri mizi.', author: 'Lara, zlata prinašalka' },
    { text: 'Moja psička seniorka, ki je sicer zelo izbirčna, ima rada prav vse okuse. Tudi tole linijo, ki je malček bolj dietna.', author: 'Nina G.' },
    { text: 'Kali z veseljem je tudi Light brikete. Upam, da se bo poznalo tudi kaj na teži.', author: 'Natalija Z.' },
  ],
  'vet-sensitive': [
    { text: 'Naša Ivi je dobila čudne izpuščaje okoli vratu – kupili smo to hrano in jo ima zelo rada.', author: 'Katja Z.' },
    { text: 'Kuža ima manj želodčnih težav, manj bruhanja in manj driske.', author: 'Urška P.' },
    { text: 'Prvi briketi, ki jih je naša psička pojedla brez da bi prej vohala par minut. Neverjetno!', author: 'Damjana G.' },
    { text: 'Ima lepo dlako, čvrste zobe in nima prebavnih težav.', author: 'Sonja H.' },
    { text: 'Edina suha hrana, ki jo moja zelo izbirčna psička sploh je.', author: 'Izbirčna mešanka' },
  ],
  'vet-hypo': [
    { text: 'Hrano smo kupili zaradi alergije. Praska se manj, lizanje tačk je opustil.', author: 'Damijana H.' },
    { text: 'Imel je stalne težave s prebavo. Ta hrana mu ustreza, stanje se je normaliziralo.', author: 'Nada Š.' },
    { text: 'Odlično, manj praskanja, čvrst kakec.', author: 'Bojana P.' },
    { text: 'Eden izmed okusov, ki ga ne moreta nehati jesti. Toplo priporočamo vsem izbirčnežem.', author: 'Ana Z.' },
    { text: 'Najboljša hrana za mojo Ameriško akito. Priporočam!', author: 'Roman S.' },
  ],
  'default': [
    { text: 'Hrana je vrhunska. Ne menjamo več. Prebava je super, počutje kužkov vidno izboljšano, kožušček svetleč.', author: 'Nastja K.' },
    { text: 'Priporočamo – že 8 let. Poskušali smo tudi hrano drugih proizvajalcev, pa psu ni ustrezala.', author: 'Mojca P.' },
    { text: 'Nima nobenih prebavnih ali drugih težav in tudi dlaka ji manj izpada kot pri drugi znamki hrane.', author: 'Aleša D.' },
  ]
};

const QUOTES_WET = {
  'menu-chicken': [
    { text: 'Vesela sem, da moja psička sedaj rada jé. Prej je zavračala hrano, prav težko obdobje je bilo z njo!', author: 'Tatjana M.' },
    { text: 'Bernski planšar jo obožuje, težav s prebavo nima nikoli po njej, čeprav je sicer občutljiv.', author: 'Lina N.' },
    { text: 'Velik delež beljakovin in prijeten vonj. Opazno v obliki iztrebka – temen in čvrst.', author: 'Roman F.' },
    { text: 'Res dišijo, naš kuža jih obožuje. Zelo praktično pakiranje.', author: 'Neva S.' },
    { text: 'Naša izbirčna zbira kombinira mokro in suho hrano – posoda je polizana.', author: 'Karmen H.' },
  ],
  'menu-fish': [
    { text: 'V suho hrano vmešam mokro. Menu Fish obožujeta, na njuno občutljivo prebavo jima zelo paše!', author: 'Karmen S.' },
    { text: 'Prebava je odlična – vzamemo s sabo na dopust namesto surove hrane.', author: 'Juliana V.' },
    { text: 'Ena od psic ima reakcijo na piščančjo hrano. Tole je super rešitev!', author: 'Boštjan G.' },
    { text: 'Preizkusili smo večje število različnih briketov, pa nobenih ni želela jesti. Zdaj pa je.', author: 'Tjaša R.' },
  ],
  'menu-turkey-salmon': [
    { text: 'Druge konzerve so slabo delovale na prebavo – po Platinum pa je prebava šolska.', author: 'Katka K.' },
    { text: 'Naša Genie po tej hrani nima prebavnih motenj, kot je to bilo pri drugih znamkah.', author: 'Oliver O.' },
    { text: 'Po tej hrani nimamo nikakršnih prebavnih težav, zato to tudi kupujemo.', author: 'Tanja D.' },
    { text: 'Moj kuža je izbirčen, ampak tole pa poje z največjim veseljem.', author: 'Mateja H.' },
  ],
  'menu-duck-turkey': [
    { text: 'Po skoraj treh letih whippet končno nima nobenih težav s prebavo.', author: 'Polona K.' },
    { text: 'S prehrano Platinum smo se končno znebili prebavnih težav. Odlična hrana!', author: 'Metka J.' },
    { text: 'Ne vsebuje piščanca in je primerna tudi za alergike. Naš pes ga ima rad.', author: 'Anja K.' },
    { text: 'Dlaka našega Lotija je vsak dan bolj svetleča odkar je hrano Platinum.', author: 'Špela Š.' },
  ],
  'menu-fish-chicken': [
    { text: 'Odkar ima mokro hrano, ki ji dam na lizalnik, imamo mir pri kosilu.', author: 'Natalija Z.' },
    { text: 'Platinum mokra hrana je edina, katere vonj zelo spominja na doma kuhano hrano. Kuža jo obožuje.', author: 'Maja L.' },
    { text: 'Linc ima drugače ribo rad samo svežo, ampak pred Platinum se ni obotavljal.', author: 'Urška K.' },
    { text: 'Top hrana, moja jo poje brez težav.', author: 'Nina T.' },
    { text: 'Vrhunska hrana! Nepogešljiva za opoldanski obrok naših mladičev.', author: 'Ana Z.' },
  ],
  'menu-beef-chicken': [
    { text: 'Naša ovčarka to pa tako zmaže, da polize celo posodo. Ta hrana res diši!', author: 'Karmen H.' },
    { text: 'Suhih briketov se velikokrat naveliča. Pri mokri hrani pa je samo vprašanje, kdaj mu jo damo.', author: 'Tim Ž.' },
    { text: 'Edina hrana, ki se je naš izbirčni kuža ne naveliča.', author: 'Miss L.' },
    { text: 'Platinum hrana je enostavno najboljša. Moj pes je testiral večinoma izdelkov in vsi so super.', author: 'Tamara Š.' },
    { text: 'Naša psička že 3 leta jé mokro hrano Platinum – zanjo je najboljša.', author: 'Darija N.' },
  ],
  'menu-iberico-turkey': [
    { text: 'Naša Grace je zelo izbirčna, ampak to pa poje vse, celo polize posodo. Super ste!', author: 'Karmen H.' },
    { text: 'Naša Flika je alergik in s to hrano nima več problemov, pa tudi dobro jo prebavlja.', author: 'Marija S.' },
    { text: 'Edino te hrane se moja kuža ne naveliča.', author: 'Mateja K.' },
    { text: 'Mokra hrana je super popestritev briketov. S takim veseljem jih je, kot da je zadnja hrana na svetu.', author: 'Gregor F.' },
    { text: 'Vzamemo na dopust namesto surove hrane. Tango še posodo poliže. Odlično!', author: 'Juliana V.' },
  ],
  'menu-puppy': [
    { text: 'Naša Koa je bila zelo izbirčna z občutljivim želodčkom – ta hrana ji je pomagala, da je sploh kaj pojedla.', author: 'Miha K.' },
    { text: 'Tako okusna, da se je našemu pubertetniki kar mešalo. Ni pomislil, da bi jo ignoriral.', author: 'Nina M.' },
    { text: 'Naših 6 malčkov z veseljem poje Puppy Chicken, tako da smo naročili že drugi paket.', author: 'Nadja S.' },
    { text: 'S hrano Puppy smo zelo zadovoljni – mladičku zelo odgovarja, nobenih težav.', author: 'Saša H.' },
    { text: 'Prvič sem ga dobila za darilo – sedaj ga naročam, saj ga naš mladenič zelo rad pospravi.', author: 'Dragica P.' },
  ],
  'default': [
    { text: 'Ta mokra hrana diši prav po pašteti – naši psički jo vmešamo med brikete in vse zmaže. Prebavnih težav pa konec!', author: 'Metka J.' },
    { text: 'Mojemu kužku se meša od veselja, ko mu postrežem s to hrano.', author: 'Živa D.' },
    { text: 'Moja kosmatinka obožuje to hrano in po tej hrani nimamo nikakršnih prebavnih težav.', author: 'Tanja D.' },
  ]
};

function pickQuote(pool, productId) {
  var arr = pool[productId] || pool['default'];
  return arr[Math.floor(Math.random() * arr.length)];
}

// ===== NAVIGATION =====
function showScr(idx) {
  SCREENS.forEach((id,i) => {
    document.getElementById(id).classList.toggle('active', i === idx);
  });
  S.step = idx;
  if (idx === 1 && !S._startTime) S._startTime = Date.now();
  // Wider container for results page
  document.getElementById('pet-food-finder-app').classList.toggle('results-active', idx === 9);
  // Skrij sticky CTA ko nismo na results
  if (idx !== 9) {
    var sEl = document.getElementById('sticky-cta');
    if (sEl) sEl.classList.remove('visible');
    if (_stickyObserver) { _stickyObserver.disconnect(); _stickyObserver = null; }
  }
  // Email screen: preveri stanje gumba ob prikazu
  if (idx === 7) checkEmailReady();
  // iOS Chrome/Safari fix: force reflow + scrollIntoView kot backup
  var scEl = document.getElementById(SCREENS[idx]);
  void scEl.offsetHeight; // force reflow
  window.scrollTo(0,0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  scEl.scrollIntoView({block:'start'});
  setTimeout(function(){ window.scrollTo(0,0); scEl.scrollIntoView({block:'start'}); }, 80);
}

function startQuiz() {
  // Name + owner name already captured on welcome screen via onNameInput/onOwnerInput
  S.name = document.getElementById('inp-name').value.trim();
  S.name = S.name.charAt(0).toUpperCase() + S.name.slice(1);
  ga4('quiz_start', { quiz_name: 'pet-food-finder' });
  prepareScr(1); // Q2 = idx 1 (Q1 belief removed)
  showScr(1);
}

function goBack() {
  if (S.step > 1) {
    let target = S.step - 1;
    // Vsi psi (vključno z mladiči) izberejo aktivnost
    restoreScr(target);
    showScr(target);
  } else showScr(0);
}

function goNext() {
  let next = S.step + 1;

  // Prepare next screen
  prepareScr(next);
  showScr(next);
}

function prepareScr(idx) {
  const n = S.name || 'tvoj pes';
  const na = acc(n); // accusative: "Maxa" / "Luno"
  const np = poss(n); // possessive: "Maxov" / "Lunin"

  // Render progress bar for Q2-Q7 + email (idx 1-7)
  if (idx >= 1 && idx <= 7) renderProgressBar(idx);

  if (idx === 1) {
    // Q2: Inline sentence (starost + spol + pasma)
    document.getElementById('q2-title').textContent = 'Povej nam o ' + n + '!';
    document.getElementById('q2-name').textContent = n;
    // Reset
    S.lifeStage = null;
    S.gender = null;
    S.breed = null;
    S.ageMonths = null;
    document.getElementById('sel-gender').selectedIndex = 0;
    document.getElementById('inp-age').value = '';
    document.getElementById('sel-age-unit').selectedIndex = 1; // 'let' default
    document.getElementById('inp-breed').value = '';
    document.getElementById('q2-quote').textContent = '';
    document.getElementById('btn-q2').disabled = true;
  }
  if (idx === 2) {
    // Q3: Teža + Body Condition
    document.getElementById('q3-title').textContent = 'Koliko tehta ' + n + '?';
    document.getElementById('adult-w-wrap').style.display = S.lifeStage === 'puppy' ? 'block' : 'none';
    document.getElementById('q3-sub').textContent = S.lifeStage === 'puppy'
      ? 'Trenutna teža + pričakovana odrasla teža.'
      : 'Prilagodimo količino za zdravo kondicijo.';
    // BC labele glede na spol
    const f = S.gender === 'female';
    document.getElementById('lb-bc1').textContent = f ? 'Presuha' : 'Presuh';
    document.getElementById('lb-bc4').textContent = f ? 'Malce pretežka' : 'Malce pretežek';
    document.getElementById('lb-bc5').textContent = f ? 'Pretežka' : 'Pretežek';
  }
  if (idx === 3) {
    // Q4: Aktivnost
    const f3 = S.gender === 'female';
    document.getElementById('q4-title').textContent = f3 ? ('Kako aktivna je ' + n + '?') : ('Kako aktiven je ' + n + '?');
    // Labele kartic glede na spol
    document.getElementById('lb-low').textContent = f3 ? 'Kraljica kavča' : 'Kralj kavča';
    document.getElementById('lb-normal').textContent = f3 ? 'Aktivna' : 'Aktiven';
    document.getElementById('lb-high').textContent = f3 ? 'Zelo aktivna' : 'Zelo aktiven';
    // Vse 4 kartice vedno vidne — senior logika se obravnava v calcResults
    // Reset
    S.activity = null;
    document.querySelectorAll('#scr-q4 .oc').forEach(c => c.classList.remove('sel'));
    document.getElementById('btn-q4').disabled = true;
  }
  if (idx === 4) {
    // Q5: Ješčnost
    document.getElementById('q5-title').textContent = 'Kako je ' + n + ' z ješčnostjo?';
    // Labele kartic glede na spol
    const f5 = S.gender === 'female';
    document.getElementById('lb-good').textContent = f5 ? 'Dobra jedka' : 'Dober jedec';
    document.getElementById('lb-sometimes').textContent = f5 ? 'Včasih izbirčna' : 'Včasih izbirčen';
    document.getElementById('lb-veryPicky').textContent = f5 ? 'Zelo izbirčna' : 'Zelo izbirčen';
    // Reset
    S.eatingHabits = null;
    document.querySelectorAll('#scr-q5 .oc').forEach(c => c.classList.remove('sel'));
    document.getElementById('q5-quote').textContent = '';
    document.getElementById('btn-q5').disabled = true;
  }
  if (idx === 5) {
    // Q6: Trenutna hrana (inline sentence + brand)
    document.getElementById('q6-title').textContent = S.gender === 'female' ? ('S čim jo trenutno hraniš?') : ('S čim ga trenutno hraniš?');
    document.getElementById('q6-name').textContent = n;
    // Reset
    S.currentFood = null;
    S.currentBrand = null;
    document.getElementById('sel-food-type').selectedIndex = 0;
    document.getElementById('inp-brand').value = '';
    document.getElementById('q6-brand-line').style.display = 'none';
    document.getElementById('btn-q6').disabled = true;
  }
  if (idx === 6) {
    // Q7: Alergije + Health (IMA/NIMA toggle)
    document.getElementById('q7-title').textContent = 'Alergije in zdravje';
    document.getElementById('q7-name-al').textContent = n;
    document.getElementById('q7-name-health').textContent = n;
    // Default: NIMA (hidden)
    S.allergens = ['brez'];
    S.healthConditions = [];
    document.getElementById('sel-al-toggle').value = 'nima';
    document.getElementById('sel-health-toggle').value = 'nima';
    document.getElementById('q7-al-options').style.display = 'none';
    document.getElementById('q7-health-options').style.display = 'none';
    document.querySelectorAll('#scr-q7 .pill').forEach(c => c.classList.remove('sel'));
  }
  if (idx === 7) {
    // Email capture screen
    document.getElementById('em-name-title').textContent = n + ' plan';
    document.getElementById('em-optin-label').textContent = 'Želim prejemati nasvete za ' + n + ' in ekskluzivne ponudbe';
    document.getElementById('btn-email-submit').textContent = 'Po\u0161lji ' + n + ' plan na email \u2192';
  }
}

// ===== RESTORE SCREEN (goBack — NO state reset, restore DOM from S) =====
function restoreScr(idx) {
  const n = S.name || 'tvoj pes';
  const na = acc(n);
  const np = poss(n);

  // Render progress bar
  if (idx >= 1 && idx <= 7) renderProgressBar(idx);

  if (idx === 1) {
    // Q2
    document.getElementById('q2-title').textContent = 'Povej nam o ' + n + '!';
    document.getElementById('q2-name').textContent = n;
    if (S.gender) document.getElementById('sel-gender').value = S.gender;
    if (S.breed) document.getElementById('inp-breed').value = S.breed;
    if (S.lifeStage && S.ageMonths) {
      document.getElementById('q2-quote').textContent = getAgeQuote(S.name, S.ageMonths, S.lifeStage);
    }
    updateQ2Emotional();
    document.getElementById('btn-q2').disabled = !(S.gender && S.lifeStage);
  }
  if (idx === 2) {
    // Q3
    document.getElementById('q3-title').textContent = 'Koliko tehta ' + n + '?';
    document.getElementById('adult-w-wrap').style.display = S.lifeStage === 'puppy' ? 'block' : 'none';
    document.getElementById('q3-sub').textContent = S.lifeStage === 'puppy'
      ? 'Trenutna teža + pričakovana odrasla teža.'
      : 'Prilagodimo količino za zdravo kondicijo.';
    if (S.weightKg) document.getElementById('inp-weight').value = String(S.weightKg);
    if (S.adultWeightKg) document.getElementById('inp-adult-w').value = String(S.adultWeightKg);
    // Show BC if weight exists
    document.getElementById('bc-wrap').style.display = S.weightKg ? '' : 'none';
    document.querySelectorAll('#bc-slider .oc').forEach(c => c.classList.toggle('sel', +c.dataset.bc === S.bodyCondition));
    const notes = { 1: 'Očitno štrleči boki, vidna vretenca in rebra so znak, da ima pes premajhno težo.', 3: 'Rebra je mogoče enostavno začutiti. Če pogledamo psa od zgoraj, vidimo njegov pas.', 4: 'Vidna je rahla zaobljenost, pes je na splošno manj definiran.', 5: 'Rebra se ne čutijo zaradi maščobnih oblog, telo je v profilu videti okroglo ali široko.' };
    document.getElementById('bc-note').textContent = notes[S.bodyCondition] || '';
    // BC labele glede na spol
    const f2 = S.gender === 'female';
    document.getElementById('lb-bc1').textContent = f2 ? 'Presuha' : 'Presuh';
    document.getElementById('lb-bc4').textContent = f2 ? 'Malce pretežka' : 'Malce pretežek';
    document.getElementById('lb-bc5').textContent = f2 ? 'Pretežka' : 'Pretežek';
    document.getElementById('btn-q3').disabled = !(S.weightKg && S.bodyCondition);
  }
  if (idx === 3) {
    // Q4
    const f4 = S.gender === 'female';
    document.getElementById('q4-title').textContent = f4 ? ('Kako aktivna je ' + n + '?') : ('Kako aktiven je ' + n + '?');
    document.getElementById('lb-low').textContent = f4 ? 'Kraljica kavča' : 'Kralj kavča';
    document.getElementById('lb-normal').textContent = f4 ? 'Aktivna' : 'Aktiven';
    document.getElementById('lb-high').textContent = f4 ? 'Zelo aktivna' : 'Zelo aktiven';
    document.querySelectorAll('#scr-q4 .oc').forEach(c => c.classList.remove('sel'));
    if (S.activity) {
      document.getElementById('opt-' + S.activity).classList.add('sel');
      document.getElementById('btn-q4').disabled = false;
    } else {
      document.getElementById('btn-q4').disabled = true;
    }
  }
  if (idx === 4) {
    // Q5
    document.getElementById('q5-title').textContent = 'Kako je ' + n + ' z ješčnostjo?';
    const f6 = S.gender === 'female';
    document.getElementById('lb-good').textContent = f6 ? 'Dobra jedka' : 'Dober jedec';
    document.getElementById('lb-sometimes').textContent = f6 ? 'Včasih izbirčna' : 'Včasih izbirčen';
    document.getElementById('lb-veryPicky').textContent = f6 ? 'Zelo izbirčna' : 'Zelo izbirčen';
    document.querySelectorAll('#scr-q5 .oc').forEach(c => c.classList.remove('sel'));
    if (S.eatingHabits) {
      document.getElementById('opt-' + S.eatingHabits).classList.add('sel');
      document.getElementById('q5-quote').textContent = EATING_QUOTES[S.eatingHabits] || '';
      document.getElementById('btn-q5').disabled = false;
    } else {
      document.getElementById('q5-quote').textContent = '';
      document.getElementById('btn-q5').disabled = true;
    }
  }
  if (idx === 5) {
    // Q6
    document.getElementById('q6-title').textContent = S.gender === 'female' ? ('S čim jo trenutno hraniš?') : ('S čim ga trenutno hraniš?');
    document.getElementById('q6-name').textContent = n;
    if (S.currentFood) {
      document.getElementById('sel-food-type').value = S.currentFood;
      const showBrand = !['barf','kuhamo'].includes(S.currentFood);
      document.getElementById('q6-brand-line').style.display = showBrand ? '' : 'none';
      if (S.currentBrand) document.getElementById('inp-brand').value = S.currentBrand;
      document.getElementById('btn-q6').disabled = false;
    } else {
      document.getElementById('sel-food-type').selectedIndex = 0;
      document.getElementById('q6-brand-line').style.display = 'none';
      document.getElementById('btn-q6').disabled = true;
    }
  }
  if (idx === 6) {
    // Q7
    document.getElementById('q7-title').textContent = 'Alergije in zdravje';
    document.getElementById('q7-name-al').textContent = n;
    document.getElementById('q7-name-health').textContent = n;
    const hasAllergens = S.allergens.length > 0 && !S.allergens.includes('brez');
    document.getElementById('sel-al-toggle').value = hasAllergens ? 'ima' : 'nima';
    document.getElementById('q7-al-options').style.display = hasAllergens ? 'block' : 'none';
    const hasHealth = S.healthConditions.length > 0;
    document.getElementById('sel-health-toggle').value = hasHealth ? 'ima' : 'nima';
    document.getElementById('q7-health-options').style.display = hasHealth ? 'block' : 'none';
    document.querySelectorAll('#q7-al-options .pill').forEach(c => {
      const v = c.getAttribute('onclick').match(/'(.+)'/)[1];
      c.classList.toggle('sel', S.allergens.includes(v));
    });
    document.querySelectorAll('#health-grid .pill').forEach(c => {
      const v = c.getAttribute('onclick').match(/'(.+)'/)[1];
      c.classList.toggle('sel', S.healthConditions.includes(v));
    });
  }
  if (idx === 7) {
    // Email
    document.getElementById('em-name-title').textContent = (S.name || 'tvoj pes') + ' plan';
    document.getElementById('em-optin-label').textContent = 'Želim prejemati nasvete za ' + (S.name || 'tvojega psa') + ' in ekskluzivne ponudbe';
    document.getElementById('btn-email-submit').textContent = 'Po\u0161lji ' + (S.name || 'tvoj') + ' plan na email \u2192';
  }
}

// ===== WELCOME: PET NAME =====
function onNameInput() {
  const raw = document.getElementById('inp-name').value.trim();
  S.name = raw.length > 0 ? raw.charAt(0).toUpperCase() + raw.slice(1) : '';
  updateWelcomeCTA();
}

function updateWelcomeCTA() {
  const btn = document.getElementById('btn-q1');
  btn.disabled = !S.name;
  const displayName = S.name ? S.name.charAt(0).toUpperCase() + S.name.slice(1).toLowerCase() : '';
  btn.textContent = S.name ? `Najdi hrano za ${displayName} →` : 'Začni →';
}

// ===== EMAIL: OWNER NAME (opcijsko) =====
function onOwnerEmailInput() {
  const raw = document.getElementById('inp-owner-email').value.trim();
  S.ownerName = raw.length > 0 ? raw.charAt(0).toUpperCase() + raw.slice(1) : '';
}

// ===== Q2: AGE + GENDER + BREED (inline sentence) =====
const BREEDS = [
  'Mešanec',
  // A
  'Afganistanski hrt','Airedalski terier','Akita','Aljaski malamut',
  'Ameriški buldog','Ameriški koker španjel','Ameriški pit bull terier','Ameriški staffordshirski terier',
  'Anatolski pastirski pes','Angleški buldog','Angleški koker španjel','Angleški seter','Angleški špringer španjel',
  'Appenzelerski planšarski pes','Argentinska doga','Avstralski govedar','Avstralski ovčar','Avstrijski pinč',
  // B
  'Basenji','Baset','Bavarski barvar','Beagle','Beauceron','Bedlingtonski terier','Belgijski ovčar',
  'Bernardinec','Bernski planšarski pes','Bolonjec','Border koli','Borderski terier','Bordojska doga',
  'Bosanski barak','Boston terier','Bradati škotski ovčar','Brazilska fila','Bretonski ptičar',
  'Briard','Broholmer','Bruseljski grifon','Bulmastif','Bulterier',
  // C, Č
  'Cane corso','Cairnski terier','Coton de Tulear',
  'Črni ruski terier','Češki terier','Češkoslovaški volčjak','Čivava','Čov-čov',
  // D
  'Dalmatinec','Doberman','Dolgodlaki škotski ovčar',
  // E
  'Entlebuški planšarski pes','Evrazijec',
  // F
  'Faraonski pes','Finski špic','Flandrijski govedar','Francoski buldog',
  // G
  'Gladkodlaki prinašalec','Gordon seter',
  // H
  'Havanski bišon','Hovawart','Hrvaški ovčar',
  // I
  'Irski seter','Irski terier','Irski vodni španjel','Irski volčji hrt',
  'Istrski kratkodlaki gonič','Istrski resasti gonič','Italijanski špic',
  // J
  'Japonski špic','Jazbečar','Južnoruski ovčar',
  // K
  'Kanaanski pes','Kanarska doga','Kangal','Karelski medvedar','Katalonski ovčar',
  'Kavkaški ovčar','Kerryjski modri terier','Kitajski goli pes','Kodrasti bišon',
  'Kodrasti prinašalec','Komondor','Kraški ovčar','Kratkodlaki foksterier',
  'Kromforlandec','Kunčji jazbečar','Kuvas',
  // L
  'Labradorec','Lagotto romagnolo','Lakelandski terier','Landseer','Lasa-apso','Leonberžan',
  // M
  'Mali angleški hrt','Mali italijanski hrt',
  'Malinois','Maltežan','Mastif','Mehiški goli pes','Mehkodlaki pšenični terier','Mops','Mudi',
  // N
  'Neapeljski mastif','Nemška doga','Nemški bokser','Nemški lovski terier','Nemški ovčar',
  'Nemški pinč','Nizozemski ovčar','Norfolški terier','Norveški špic','Novofundlanec',
  'Novoškotski prinašalec',
  // O
  'Opičji pinč',
  // P
  'Papillon','Pekinčan','Pikardijski ovčar','Pirenejski planinski pes',
  'Planinski gonič','Podhalanski ovčar','Poenter','Poljski nižinski ovčar','Pomeranec',
  'Portugalski vodni pes','Posavski gonič','Pritlikavi bulterier','Pritlikavi jazbečar',
  'Pritlikavi pinč','Pritlikavi šnavcer','Pudel','Puli','Pumi',
  // R
  'Resasti foksterier','Rodezijski grebenar',
  'Rottweiler','Ruski hrt',
  // S, Š
  'Saarloosov volčjak','Saluki','Samojed','Schapendoes',
  'Sibirski husky','Skye terier','Slovaški čuvač','Slovaški gonič',
  'Slovenski planinski gonič','Srbski gonič','Srednjeazijska ovčarka','Srednji šnavcer',
  'Staffordshirski bulterier','Staroangleski ovčar',
  'Šar pej','Šarplaninec','Šetlandski ovčar','Šiba inu','Šiperke','Šnavcer',
  'Španjel Cavalier King Charles','Španjel King Charles','Španski vodni pes',
  'Škotski jelenar','Škotski terier',
  'Švedski laphund','Ši-cu','Švicarski beli ovčarski pes',
  // T
  'Tajski grebenar','Terier Glen of Imaal','Terier Jack Russell','Terier Parson Russell',
  'Tibetanski mastif','Tibetanski španjel','Tibetanski terier','Tornjak','Tosa',
  // V
  'Valižanski ovčar Cardigan','Valižanski ovčar Pembroke','Valižanski terier','Vižla',
  'Veliki japonski pes','Veliki šnavcer','Veliki švicarski planšarski pes','Vidrar',
  // W
  'Weimaranec','Welsh korgi','Whippet',
  // Y
  'Yorkshirski terier',
  // Z
  'Zahodnovišavski beli terier','Zlati prinašalec',
  'Ne vem'
];

// Personalized age quote: name + age summary
function getAgeQuote(name, months, lifeStage) {
  const n = name || 'tvoj pes';
  let ageStr;
  if (months >= 12) {
    const years = Math.floor(months / 12);
    ageStr = years + ' ' + (years === 1 ? 'leto' : years === 2 ? 'leti' : years <= 4 ? 'leta' : 'let');
  } else {
    ageStr = months + ' ' + (months === 1 ? 'mesec' : months === 2 ? 'meseca' : months <= 4 ? 'mesece' : 'mesecev');
  }
  const njegov = S.gender === 'female' ? 'njen' : 'njegov';
  return `${n}, ${ageStr} — prilagodimo ${njegov} plan. 🎯`;
}

// Slovenian grammar: age unit labels
function ageUnitLabel(n, unit) {
  if (unit === 'months') {
    if (n === 1) return 'mesec';
    if (n === 2) return 'meseca';
    if (n === 3 || n === 4) return 'mesece';
    return 'mesecev';
  } else {
    if (n === 1) return 'leto';
    if (n === 2) return 'leti';
    if (n === 3 || n === 4) return 'leta';
    return 'let';
  }
}

function onQ2Change() {
  // Spol
  const genderEl = document.getElementById('sel-gender');
  const gVal = genderEl.value;
  S.gender = gVal || null;
  // Remove placeholder style when gender is selected
  if (gVal) genderEl.classList.remove('placeholder');
  else genderEl.classList.add('placeholder');

  // Update "star/stara" based on gender
  const starLabel = document.getElementById('q2-star-label');
  if (starLabel) starLabel.textContent = S.gender === 'female' ? 'stara' : 'star';

  // Starost: number + unit
  const ageEl = document.getElementById('inp-age');
  ageEl.value = ageEl.value.replace(/[^0-9]/g, '').replace(/^0+(\d)/, '$1');
  const ageNum = parseInt(ageEl.value);
  const unit = document.getElementById('sel-age-unit').value;

  if (ageNum > 0) {
    const max = (unit === 'months') ? 18 : 20;
    const clamped = Math.min(ageNum, max);
    if (ageNum > max) ageEl.value = clamped;

    const months = (unit === 'years') ? clamped * 12 : clamped;
    S.ageMonths = months;

    // Dynamic unit label: "1 leto", "2 leti", "5 let", "1 mesec", "3 mesece"
    const selUnit = document.getElementById('sel-age-unit');
    const monthsOpt = selUnit.querySelector('[value="months"]');
    const yearsOpt = selUnit.querySelector('[value="years"]');
    monthsOpt.textContent = ageUnitLabel(clamped, 'months');
    yearsOpt.textContent = ageUnitLabel(clamped, 'years');

    // Preliminary lifeStage — da se v Q3 prikaže polje za odraslo težo
    // Končna odločitev puppy/adult se zgodi v calcResults() glede na velikost psa
    if (months <= 12) {
      S.lifeStage = 'puppy';
    } else {
      S.lifeStage = 'adult';
    }

    // Personalized quote
    document.getElementById('q2-quote').textContent = getAgeQuote(S.name, months, S.lifeStage);
  } else {
    S.lifeStage = null;
    S.ageMonths = null;
    document.getElementById('q2-quote').textContent = '';
  }

  // Emotional line: show when gender + age are filled
  updateQ2Emotional();
  checkQ2Ready();
}

function updateQ2Emotional() {
  const el = document.getElementById('q2-emotional');
  if (S.gender && S.ageMonths && S.breed) {
    el.textContent = '...in si zasluži najboljše. ❤️';
    el.classList.add('visible');
  } else {
    el.classList.remove('visible');
  }
}

function onBreedInput() {
  const val = document.getElementById('inp-breed').value.trim();
  S.breed = val || null;
  renderBreedDropdown(val.toLowerCase());
  updateQ2Emotional();
  checkQ2Ready();
}
function renderBreedDropdown(filter) {
  const dd = document.getElementById('breed-dropdown');
  if (!filter) { dd.classList.remove('open'); return; }
  var starts = BREEDS.filter(b => b.toLowerCase().startsWith(filter));
  var contains = starts.length > 0 ? starts : BREEDS.filter(b => b.toLowerCase().includes(filter));
  if (contains.length === 0) { dd.classList.remove('open'); return; }
  dd.innerHTML = contains.slice(0, 8).map(b =>
    '<div class="breed-opt" onmousedown="selectBreed(\'' + b.replace(/'/g, "\\'") + '\')">' + b + '</div>'
  ).join('');
  dd.classList.add('open');
}
function selectBreed(b) {
  document.getElementById('inp-breed').value = b;
  S.breed = b;
  document.getElementById('breed-dropdown').classList.remove('open');
  updateQ2Emotional();
  checkQ2Ready();
}
function onBreedFocus() {
  const val = document.getElementById('inp-breed').value.trim().toLowerCase();
  if (val) renderBreedDropdown(val);
  else {
    // Show all breeds on empty focus
    const dd = document.getElementById('breed-dropdown');
    dd.innerHTML = BREEDS.slice(0, 10).map(b =>
      '<div class="breed-opt" onmousedown="selectBreed(\'' + b.replace(/'/g, "\\'") + '\')">' + b + '</div>'
    ).join('');
    dd.classList.add('open');
  }
}
function onBreedBlur() {
  setTimeout(function() { document.getElementById('breed-dropdown').classList.remove('open'); }, 200);
}

function checkQ2Ready() {
  // Spol + starost obvezna, pasma opcijska
  document.getElementById('btn-q2').disabled = !(S.gender && S.lifeStage);
}

// ===== Q3: WEIGHT + BODY CONDITION =====
// Growth factors: W(t) = f(t) × W_adult — za validacijo puppy teže
// Mali (<10kg), Srednji (10-25kg), Veliki (>25kg)
const GROWTH_FACTORS = {
  small:  { 2: 0.30, 4: 0.60, 6: 0.80, 8: 0.90, 10: 0.95, 12: 1.00 },
  medium: { 2: 0.25, 4: 0.50, 6: 0.66, 8: 0.80, 10: 0.90, 12: 0.95 },
  large:  { 2: 0.15, 4: 0.35, 6: 0.55, 8: 0.70, 10: 0.85, 12: 0.92 }
};
function getGrowthFactor(adultW, ageMonths) {
  const group = adultW < 10 ? 'small' : adultW <= 25 ? 'medium' : 'large';
  const factors = GROWTH_FACTORS[group];
  // Interpolacija med bracketi (2,4,6,8,10,12)
  const ages = [2, 4, 6, 8, 10, 12];
  if (ageMonths <= ages[0]) return factors[ages[0]];
  if (ageMonths >= ages[ages.length - 1]) return factors[ages[ages.length - 1]];
  for (var i = 0; i < ages.length - 1; i++) {
    if (ageMonths >= ages[i] && ageMonths <= ages[i + 1]) {
      var t = (ageMonths - ages[i]) / (ages[i + 1] - ages[i]);
      return factors[ages[i]] + (factors[ages[i + 1]] - factors[ages[i]]) * t;
    }
  }
  return factors[ages[0]];
}
let _weightWarnTimer = null;
function checkWeightWarning() {
  clearTimeout(_weightWarnTimer);
  _weightWarnTimer = setTimeout(_doCheckWeightWarning, 1500);
}
function _doCheckWeightWarning() {
  const warn = document.getElementById('weight-warn');
  if (!warn) return;
  // Samo za puppyje (2-12 mesecev)
  if (!S.ageMonths || S.ageMonths > 12 || !S.weightKg || !S.adultWeightKg) {
    warn.style.display = 'none';
    return;
  }
  // Check 1: trenutna teža > odrasla teža
  if (S.weightKg > S.adultWeightKg) {
    warn.textContent = '⚠ Trenutna teža je večja od pričakovane odrasle — preveri vnos.';
    warn.style.display = '';
    return;
  }
  // Check 2: growth factor ±25%
  const f = getGrowthFactor(S.adultWeightKg, S.ageMonths);
  const expected = f * S.adultWeightKg;
  const lo = expected * 0.75;
  const hi = expected * 1.25;
  if (S.weightKg < lo || S.weightKg > hi) {
    warn.textContent = '⚠ Trenutna teža se ne sklada s pričakovano odraslo — preveri vnos.';
    warn.style.display = '';
    return;
  }
  warn.style.display = 'none';
}
function sanitizeWeight(el) {
  // Only whole numbers (1-80), no decimals, no commas, no dots
  let v = el.value.replace(/[^0-9]/g, '');
  // Remove leading zeros
  if (v.length > 1 && v[0] === '0') v = v.replace(/^0+/, '');
  // Clamp to max 80
  const num = parseInt(v);
  if (!isNaN(num) && num > 80) v = '80';
  el.value = v;
}
function parseWeight(val) {
  const n = parseInt(val);
  if (isNaN(n) || n <= 0) return null;
  return Math.min(80, Math.max(1, n));
}
function onWeightInput() {
  const wEl = document.getElementById('inp-weight');
  sanitizeWeight(wEl);
  S.weightKg = parseWeight(wEl.value);
  // Show BC cards when weight is entered
  document.getElementById('bc-wrap').style.display = S.weightKg ? '' : 'none';

  // Puppy/adult odločitev se zgodi v calcResults(), ne tukaj
  // Polje za odraslo težo ostane vidno za vse pse <= 12 mesecev
  if (S.ageMonths && S.ageMonths <= 12) {
    const awEl = document.getElementById('inp-adult-w');
    sanitizeWeight(awEl);
    S.adultWeightKg = parseWeight(awEl.value);
    document.getElementById('btn-q3').disabled = !(S.weightKg && S.adultWeightKg && S.bodyCondition);
  } else {
    S.adultWeightKg = null;
    document.getElementById('btn-q3').disabled = !(S.weightKg && S.bodyCondition);
  }
  checkWeightWarning();
}

function selectBC(val) {
  S.bodyCondition = val;
  document.querySelectorAll('#bc-slider .oc').forEach(c => c.classList.toggle('sel', +c.dataset.bc === val));
  const notes = { 1: 'Očitno štrleči boki, vidna vretenca in rebra so znak, da ima pes premajhno težo.', 3: 'Rebra je mogoče enostavno začutiti. Če pogledamo psa od zgoraj, vidimo njegov pas.', 4: 'Vidna je rahla zaobljenost, pes je na splošno manj definiran.', 5: 'Rebra se ne čutijo zaradi maščobnih oblog, telo je v profilu videti okroglo ali široko.' };
  document.getElementById('bc-note').textContent = notes[val] || '';
  // Motivational insight
  const n = S.name || 'tvoj pes';
  const bcInsights = { 1: 'Prava prehrana lahko pomaga pri pridobivanju te\u017ee \u2014 poglejmo kaj je najbolj\u0161e za ' + n + '.', 3: 'Odli\u010dno! ' + n + ' je v idealni formi \u2014 ohranimo tako! \uD83D\uDCAA', 4: 'Ni\u010d skrbi \u2014 s pravimi obroki lahko ' + n + ' varno izgubi odve\u010dne kilograme.', 5: 'Ni\u010d skrbi \u2014 s pravimi obroki lahko ' + n + ' varno izgubi odve\u010dne kilograme.' };
  document.getElementById('q3-insight').textContent = bcInsights[val] || '';
  // Enable next button if weight + BC filled
  if (S.lifeStage === 'puppy') {
    document.getElementById('btn-q3').disabled = !(S.weightKg && S.adultWeightKg && S.bodyCondition);
  } else {
    document.getElementById('btn-q3').disabled = !(S.weightKg && S.bodyCondition);
  }
}

// ===== Q4: ACTIVITY =====
const ACTIVITY_DESC = {
  low: 'Lenuh, ki je eno s kavčem. Krajši sprehodi in počitek.',
  normal: '1–2 uri gibanja na dan — sprehodi, igra, raziskovanje.',
  high: 'Tek, agility, dolgi sprehodi — gibanje je življenje!',
  pro: 'Trening, tekmovanja ali delovni pes — vrhunska obremenitev.'
};
function selectActivity(level) {
  S.activity = level;
  document.querySelectorAll('#scr-q4 .oc').forEach(c => c.classList.remove('sel'));
  document.getElementById('opt-' + level).classList.add('sel');
  document.getElementById('q4-desc').textContent = ACTIVITY_DESC[level] || '';
  // Motivational insight
  const actInsights = { low: 'Tudi mirnej\u0161i psi potrebujejo kvalitetno prehrano \u2014 prilagodimo porcije.', normal: 'Super! Aktiven pes = sre\u010den pes! \uD83D\uDC3E', high: 'Pravi \u0161portnik! Poskrbimo za dovolj energije. \u26A1', pro: 'Wow, pravi atlet! Poskrbimo za dovolj energije. \u26A1' };
  document.getElementById('q4-insight').textContent = actInsights[level] || '';
  document.getElementById('btn-q4').disabled = false;
}

// ===== Q5: EATING HABITS =====
const EATING_DESC = {
  good: 'Poje vse brez težav',
  sometimes: 'Včasih zavrne ali je počasi',
  veryPicky: 'Zavrača hrano, dolgo jé'
};
const EATING_QUOTES = {
  good: 'Super! Prava radost za vsakega lastnika! 🎉',
  sometimes: 'Nič hudega — prava hrana naredi čudeže!',
  veryPicky: 'Misli, da je pasji Gordon Ramsay? 😄'
};
function selectEating(e) {
  S.eatingHabits = e;
  document.querySelectorAll('#scr-q5 .oc').forEach(c => c.classList.remove('sel'));
  document.getElementById('opt-' + e).classList.add('sel');
  document.getElementById('q5-desc').textContent = EATING_DESC[e] || '';
  document.getElementById('q5-quote').textContent = EATING_QUOTES[e] || '';
  document.getElementById('btn-q5').disabled = false;
}

// ===== Q6: CURRENT FOOD (inline sentence + brand) =====
const BRANDS = [
  'Acana','Advance','Almo Nature','Animonda','Applaws','Arden Grange',
  'Barking Heads','Belcando','Bosch','Bozita','Brit',
  'Calibra','Canagan','Carnilove','Chappi','Concept for Life',
  'Dog Chow','Eukanuba',
  'Farmina','Fitmin','Forza10','Friskies',
  'Gemon','Gosbi','GranataPet','Greenwoods',
  'Happy Dog','Hill\'s',
  'IAMS','Isegrim',
  'Josera',
  'Kudo',
  'Libra','Lily\'s Kitchen','Lukullus',
  'MERA','Monge','Morando',
  'N&D','Natural Trainer','Nature\'s Variety','Nuevo','Nutram',
  'Ontario','Orijen','Ownat',
  'Pedigree','Pro Plan','Purizon',
  'Rinti','Rocco','Royal Canin','Rustican',
  'Sam\'s Field','Schesir','Specific',
  'Taste of the Wild','Terra Canis','Tribal',
  'Vincent',
  'Wolf of Wilderness','WolfPack','Wolfsblut',
  'Ne vem / drugo'
];

function onQ6Change() {
  const foodEl = document.getElementById('sel-food-type');
  const foodVal = foodEl.value;
  S.currentFood = foodVal || null;
  if (foodVal) foodEl.classList.remove('placeholder');
  else foodEl.classList.add('placeholder');

  // Show brand line for commercial food types (not BARF/kuhamo)
  const showBrand = foodVal && !['barf','kuhamo'].includes(foodVal);
  document.getElementById('q6-brand-line').style.display = showBrand ? '' : 'none';
  if (!showBrand) {
    S.currentBrand = null;
    document.getElementById('inp-brand').value = '';
  }

  // Enable button when food type is selected (brand is optional)
  document.getElementById('btn-q6').disabled = !S.currentFood;
}

function onBrandInput() {
  const val = document.getElementById('inp-brand').value.trim();
  S.currentBrand = val || null;
  renderBrandDropdown(val.toLowerCase());
}
function renderBrandDropdown(filter) {
  const dd = document.getElementById('brand-dropdown-food');
  if (!filter) { dd.classList.remove('open'); return; }
  const matches = BRANDS.filter(b => b.toLowerCase().includes(filter));
  if (matches.length === 0) { dd.classList.remove('open'); return; }
  dd.innerHTML = matches.slice(0, 8).map(b =>
    '<div class="brand-opt" onmousedown="selectBrand(\'' + b.replace(/'/g, "\\'") + '\')">' + b + '</div>'
  ).join('');
  dd.classList.add('open');
}
function selectBrand(b) {
  document.getElementById('inp-brand').value = b;
  S.currentBrand = b;
  document.getElementById('brand-dropdown-food').classList.remove('open');
}
function onBrandFocus() {
  const val = document.getElementById('inp-brand').value.trim().toLowerCase();
  if (val) renderBrandDropdown(val);
  else {
    // Show popular brands on empty focus
    const popular = ['Royal Canin','Hill\'s','Acana','Orijen','Brit','Eukanuba','Pro Plan','Happy Dog'];
    const dd = document.getElementById('brand-dropdown-food');
    dd.innerHTML = popular.map(b =>
      '<div class="brand-opt" onmousedown="selectBrand(\'' + b.replace(/'/g, "\\'") + '\')">' + b + '</div>'
    ).join('');
    dd.classList.add('open');
  }
}
function onBrandBlur() {
  setTimeout(function() { document.getElementById('brand-dropdown-food').classList.remove('open'); }, 200);
}

// ===== Q7: ALLERGENS + HEALTH =====
// ===== Q7: IMA/NIMA TOGGLES =====
function onQ7AlToggle() {
  const val = document.getElementById('sel-al-toggle').value;
  document.getElementById('q7-al-options').style.display = val === 'ima' ? 'block' : 'none';
  document.getElementById('q7-al-label').textContent = val === 'ima' ? 'alergije:' : 'alergij.';
  if (val === 'nima') {
    // Clear all allergens
    S.allergens = ['brez'];
    document.querySelectorAll('#q7-al-options .pill').forEach(c => c.classList.remove('sel'));
    document.getElementById('q7-protein-info').style.display = 'none';
  } else {
    S.allergens = S.allergens.filter(x => x !== 'brez');
  }
  updateQ7Insight();
}

function onQ7HealthToggle() {
  const val = document.getElementById('sel-health-toggle').value;
  document.getElementById('q7-health-options').style.display = val === 'ima' ? 'block' : 'none';
  document.getElementById('q7-health-label').textContent = val === 'ima' ? 'zdravstvene težave:' : 'zdravstvenih težav.';
  if (val === 'nima') {
    // Clear all health conditions
    S.healthConditions = [];
    document.querySelectorAll('#health-grid .pill').forEach(c => c.classList.remove('sel'));
  }
  updateQ7Insight();
}

const PROTEIN_ALLERGENS = ['Piščanec','Govedina','Jagnjetina','Iberico (svinjina)','Puran','Riba','Račka'];
function togAllergen(a) {
  S.allergens = S.allergens.filter(x => x !== 'brez');
  const idx = S.allergens.indexOf(a);
  if (idx >= 0) S.allergens.splice(idx, 1); else S.allergens.push(a);
  document.querySelectorAll('#q7-al-options .pill').forEach(c => {
    const v = c.getAttribute('onclick').match(/'(.+)'/)[1];
    c.classList.toggle('sel', S.allergens.includes(v));
  });
  // Show protein info note if any protein allergen is selected
  const hasProtein = S.allergens.some(a => PROTEIN_ALLERGENS.includes(a));
  document.getElementById('q7-protein-info').style.display = hasProtein ? 'block' : 'none';
  updateQ7Insight();
}

function togHealth(h) {
  const idx = S.healthConditions.indexOf(h);
  if (idx >= 0) S.healthConditions.splice(idx, 1); else S.healthConditions.push(h);
  document.querySelectorAll('#health-grid .pill').forEach(c => {
    const v = c.getAttribute('onclick').match(/'(.+)'/)[1];
    c.classList.toggle('sel', S.healthConditions.includes(v));
  });
  updateQ7Insight();
}

function updateQ7Insight() {
  const el = document.getElementById('q7-insight');
  const n = S.name || 'tvoj pes';
  const hasAl = S.allergens.length > 0 && !S.allergens.includes('brez');
  const hasHealth = S.healthConditions.length > 0;
  if (hasAl || hasHealth) {
    el.textContent = 'Ni skrbi \u2014 PLATINUM ponuja re\u0161itve posebej za pse kot je ' + n + '. Poglejmo! \uD83D\uDD0D';
  } else {
    el.textContent = '';
  }
}

// ===== TOAST =====
// ===== EMAIL CAPTURE =====
function isValidEmail(e) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e);
}

function checkEmailReady() {
  const emailEl = document.getElementById('em-capture-input');
  const errEl = document.getElementById('em-error');
  const btn = document.getElementById('btn-email-submit');
  const optin = document.getElementById('em-optin').checked;
  const email = emailEl.value.trim();

  // Reset
  errEl.style.display = 'none';
  emailEl.style.borderColor = '';

  if (email && !isValidEmail(email)) {
    errEl.textContent = 'Vnesi veljaven email naslov (npr. ime@email.com)';
    errEl.style.display = 'block';
    emailEl.style.borderColor = 'var(--color-error)';
  }

  // Gumb aktiven SAMO ko: veljaven email + optin checked
  btn.disabled = !(email && isValidEmail(email) && optin);
}

function submitEmailAndContinue() {
  const emailEl = document.getElementById('em-capture-input');
  const email = emailEl.value.trim();
  if (!email || !isValidEmail(email) || !document.getElementById('em-optin').checked) {
    checkEmailReady();
    if (!email) emailEl.focus();
    return;
  }
  S.email = email;
  S.emailOptin = true;
  ga4('quiz_email_submit', { quiz_name: 'pet-food-finder' });
  console.log('📧 Email captured:', email, 'Optin:', S.emailOptin);
  // TODO: n8n webhook
  triggerLoading();
}

function skipEmail() {
  S.email = null;
  triggerLoading();
}

// ===== TRIGGER LOADING → RESULTS =====
// Loading texts are generated dynamically with pet name in triggerLoading()

function triggerLoading() {
  showScr(8); // loading screen
  document.getElementById('img-loading').src = QUIZ_IMAGES.loading;
  document.getElementById('l-sub').textContent = 'Analiziram 20+ PLATINUM receptur za ' + S.name;

  // Personalized cycling loading texts with pet name
  const loadingTexts = [
    'Analiziram ' + poss(S.name) + ' profil...',
    'Računam dnevne kalorije...',
    'Preverjam alergene...',
    'Izbiram najboljši recept...',
    'Sestavljam ' + poss(S.name) + ' plan ✓'
  ];

  // Cycling loading texts (menjava vsakih 700ms z fade)
  let textIdx = 0;
  const textEl = document.getElementById('l-text');
  textEl.textContent = loadingTexts[0];
  textEl.style.opacity = '1';
  const textInterval = setInterval(() => {
    textIdx++;
    if (textIdx < loadingTexts.length) {
      textEl.style.opacity = '0';
      setTimeout(() => {
        textEl.textContent = loadingTexts[textIdx];
        textEl.style.opacity = '1';
      }, 200);
    }
  }, 700);

  // Start stock fetch immediately (runs in parallel with loading animation)
  const res = calcResults();
  const handles = collectHandles(res);
  const stockPromise = fetchStock(handles);

  setTimeout(async () => {
    clearInterval(textInterval);
    try {
      const stockMap = await stockPromise;
      applyStock(res, stockMap);
    } catch (e) { /* graceful — render without stock info */ }
    renderResults(res);
    showScr(9); // results screen
    ga4('quiz_complete', {
      quiz_name: 'pet-food-finder',
      recommended_product: (res.byMode && res.byMode.dry && res.byMode.dry.products[0]) ? res.byMode.dry.products[0].id : null,
      default_mode: res.defaultMode
    });
    submitQuizData(res);
  }, 4000);
}

// ===== SCORING ENGINE HELPERS =====

// Pretvori quiz state v signale ki se ujemajo s pravili v quiz_scoring_rules
function getQuizSignals() {
  var signals = [];
  signals.push({ vprasanje: 'privzeto', odgovor: 'vsi' });

  var eatingMap = { good: 'dober jedec', sometimes: 'včasih izbirčen', veryPicky: 'zelo izbirčen' };
  if (S.eatingHabits && eatingMap[S.eatingHabits]) {
    signals.push({ vprasanje: 'jescnost', odgovor: eatingMap[S.eatingHabits] });
  }

  var foodMap = { briketi: 'briketi', barf: 'barf', liofilizirano: 'liofilizirano', polsuha: 'polsuha', kuhamo: 'doma kuhano', mokra: 'mokra hrana' };
  if (S.currentFood && foodMap[S.currentFood]) {
    signals.push({ vprasanje: 'trenutna_hrana', odgovor: foodMap[S.currentFood] });
  }

  if (S.healthConditions.includes('prebava')) signals.push({ vprasanje: 'zdravje', odgovor: 'prebava' });
  if (S.healthConditions.includes('skin')) signals.push({ vprasanje: 'zdravje', odgovor: 'koža in dlaka' });
  if (S.healthConditions.includes('joints')) signals.push({ vprasanje: 'zdravje', odgovor: 'sklepi' });

  var alList = S.allergens.filter(function(a) { return a !== 'brez'; });
  if (alList.length > 0) signals.push({ vprasanje: 'alergije', odgovor: 'katerakoli alergija' });

  var bcMap = { 1: 'Presuh', 2: 'Suh', 3: 'Idealen', 4: 'Malce pretežek', 5: 'Pretežek' };
  if (S.bodyCondition && bcMap[S.bodyCondition]) {
    signals.push({ vprasanje: 'telesna_kondicija', odgovor: bcMap[S.bodyCondition] });
  }

  if (S.lifeStage === 'senior') signals.push({ vprasanje: 'starost', odgovor: 'senior' });
  if (S.lifeStage === 'puppy') signals.push({ vprasanje: 'starost', odgovor: 'mladič' });

  var actMap = { low: 'nizka', normal: 'normalna', high: 'visoka', pro: 'profesionalna' };
  if (S.activity && actMap[S.activity]) {
    signals.push({ vprasanje: 'aktivnost', odgovor: actMap[S.activity] });
  }

  return signals;
}

// Vrni pravila ki se ujemajo s signali za dani tip priporočila
function matchRules(signals, tip) {
  return QUIZ_DATA.rules.filter(function(rule) {
    if (rule.priporocilo_tip !== tip) return false;
    return signals.some(function(sig) {
      return sig.vprasanje === rule.vprasanje && sig.odgovor === rule.odgovor;
    });
  });
}

// Točkuj produkte v poolu in sortiraj po skupnem seštevku (DESC)
function scorePool(pool, signals, tip) {
  var scores = {};
  pool.forEach(function(p) { scores[p.name] = 0; });

  var rules = matchRules(signals, tip);
  rules.forEach(function(rule) {
    var match = pool.find(function(p) { return p.name === rule.priporocilo_produkt; });
    if (match) {
      scores[match.name] = (scores[match.name] || 0) + (rule.tocke || 0);
    }
  });

  pool.sort(function(a, b) { return (scores[b.name] || 0) - (scores[a.name] || 0); });
  return pool;
}

function scoreFallback(pool, type) {
  var isMenu = type === 'mokra_hrana';
  var scores = {};
  var base = isMenu ? FALLBACK_SCORES.menuBase : FALLBACK_SCORES.base;
  pool.forEach(function(p) { scores[p.name] = base[p.name] || 0; });

  if (!isMenu) {
    // Eating habits bonus
    var eatBonus = FALLBACK_SCORES.eatingHabits[S.eatingHabits];
    if (eatBonus) Object.keys(eatBonus).forEach(function(k) { scores[k] = (scores[k]||0) + eatBonus[k]; });
    // Current food bonus
    var foodBonus = FALLBACK_SCORES.currentFood[S.currentFood];
    if (foodBonus) Object.keys(foodBonus).forEach(function(k) { scores[k] = (scores[k]||0) + foodBonus[k]; });
    // Health conditions
    S.healthConditions.forEach(function(hc) {
      var hb = FALLBACK_SCORES.health[hc];
      if (hb) Object.keys(hb).forEach(function(k) { scores[k] = (scores[k]||0) + hb[k]; });
    });
    // Body condition
    var bcBonus = FALLBACK_SCORES.bodyCondition[S.bodyCondition];
    if (bcBonus) Object.keys(bcBonus).forEach(function(k) { scores[k] = (scores[k]||0) + bcBonus[k]; });
    // Allergens
    var alList = S.allergens.filter(function(a) { return a !== 'brez'; });
    if (alList.length > 0) Object.keys(FALLBACK_SCORES.allergy).forEach(function(k) { scores[k] = (scores[k]||0) + FALLBACK_SCORES.allergy[k]; });
  } else {
    // Wet health bonuses
    S.healthConditions.forEach(function(hc) {
      var mb = FALLBACK_SCORES.menuHealth[hc];
      if (mb) Object.keys(mb).forEach(function(k) { scores[k] = (scores[k]||0) + mb[k]; });
    });
  }

  pool.sort(function(a, b) { return (scores[b.name]||0) - (scores[a.name]||0); });
  return pool;
}

// ===== RECOMMENDATION ENGINE =====
function calcResults() {
  S._lifeStageOriginal = S.lifeStage; // preserve before detection
  const alList = S.allergens.filter(a => a !== 'brez');
  var useScoring = QUIZ_DATA.rules.length > 0;

  // PLATINUM puppy → adult detekcija glede na velikost psa
  // Mali (<10kg): puppy do 12mo, Srednji (10-25kg): do 6mo, Veliki (>25kg): do 4mo
  if (S.lifeStage === 'puppy' && S.ageMonths) {
    const aw = S.adultWeightKg || S.weightKg;
    let puppyUntil = 12;                        // mali psi (<10kg)
    if (aw >= 10 && aw <= 25) puppyUntil = 6;   // srednji psi
    else if (aw > 25) puppyUntil = 4;            // veliki psi
    if (S.ageMonths > puppyUntil) S.lifeStage = 'adult';
  }

  // Senior detekcija glede na starost + težo
  // Mali (<10kg): 11 let, Srednji (10-25kg): 9 let, Veliki (>25kg): 7 let
  if (S.lifeStage === 'adult' && S.ageMonths) {
    const w = S.adultWeightKg || S.weightKg;
    let seniorFrom = 108; // default 9 let
    if (w && w < 10) seniorFrom = 132;
    else if (w && w > 25) seniorFrom = 84;
    if (S.ageMonths >= seniorFrom) S.lifeStage = 'senior';
  }

  // Filter by life stage
  // Senior psi dobijo adult + senior produkte (brez senior množilnika)
  // Starost vpliva na izbor izdelka, ne na količino
  let pool = PRODUCTS.filter(p => {
    if (S.lifeStage === 'puppy') return p.stage.includes('puppy');
    if (S.lifeStage === 'senior') return p.stage.includes('adult') || p.stage.includes('senior');
    return p.stage.includes('adult');
  });

  // ⛔ Product eligibility — skrij neprimerne izdelke za dano stanje
  function eligibilityFilter(p) {
    var _bc = parseInt((S.bodyCondition || '').toString().replace('bc','')) || 3;
    // Vet-Light: samo za BC4/BC5 (predebeli), ne za zelo aktivne
    if (p.special === 'light') {
      if (_bc <= 3) return false;
      if (S.activity === 'high' || S.activity === 'pro') return false;
    }
    // Vet-Senior: ne za presuhe (BC1), ne za zelo aktivne
    if (p.id === 'vet-senior') {
      if (_bc <= 1) return false;
      if (S.activity === 'high' || S.activity === 'pro') return false;
    }
    return true;
  }
  pool = pool.filter(eligibilityFilter);

  // Filter allergens
  if (alList.length > 0) {
    pool = pool.filter(p => !p.allergens.some(a => alList.includes(a)));
  }

  // Fallback: if pool empty after allergen filter, widen to adult products
  let fallbackNotice = null;
  if (pool.length === 0 && S.lifeStage !== 'adult') {
    pool = PRODUCTS.filter(p => p.stage.includes('adult')).filter(eligibilityFilter);
    if (alList.length > 0) pool = pool.filter(p => !p.allergens.some(a => alList.includes(a)));
    if (S.lifeStage === 'puppy') {
      fallbackNotice = 'puppy-allergen';
    } else if (S.lifeStage === 'senior') {
      fallbackNotice = 'senior-allergen';
    }
  }
  // Last resort: if STILL empty, use all products ignoring allergens (better than crash)
  if (pool.length === 0) {
    pool = PRODUCTS.filter(p => p.stage.includes(S.lifeStage === 'puppy' ? 'puppy' : 'adult')).filter(eligibilityFilter);
    fallbackNotice = fallbackNotice || 'no-match';
  }

  // Prioritize products
  var signals = useScoring ? getQuizSignals() : null;
  if (useScoring) {
    pool = scorePool(pool, signals, 'suha_hrana');
  } else {
    pool = scoreFallback(pool, 'suha_hrana');
  }

  // Build MENU pool (shared across wet/combo modes)
  let menuPool = MENU.filter(m => {
    if (S.lifeStage === 'puppy') return m.stage.includes('puppy');
    return m.stage.includes('adult');
  });
  if (alList.length > 0) {
    menuPool = menuPool.filter(m => !m.allergens.some(a => alList.includes(a)));
  }
  // Fallback: if menuPool empty (e.g. puppy allergic to Piščanec), try adult MENU with allergen filter
  if (menuPool.length === 0) {
    menuPool = MENU.filter(m => m.stage.includes('adult'));
    if (alList.length > 0) {
      menuPool = menuPool.filter(m => !m.allergens.some(a => alList.includes(a)));
    }
  }
  // Last resort: if STILL empty, use all adult MENU (allergen sort applied at pick time)
  var menuIsLastResort = false;
  if (menuPool.length === 0) {
    menuPool = MENU.filter(m => m.stage.includes('adult'));
    menuIsLastResort = true;
  }
  if (useScoring) {
    menuPool = scorePool(menuPool, signals, 'mokra_hrana');
  } else {
    menuPool = scoreFallback(menuPool, 'mokra_hrana');
  }

  // Pre-compute results for ALL 3 feed modes
  const byMode = {};
  ['dry', 'wet', 'combo'].forEach(mode => {
    // Clone pool products (don't mutate originals)
    let prods = pool.slice(0, mode === 'wet' ? 1 : 2).map(p => ({...p}));

    // Smart alternative: always show a meaningful second option
    // - Primary = Vetactive (special) → alt = best Adult (standard option)
    // - Primary = Adult + BC4/BC5 → alt = Vet-Light (diet option)
    // - Primary = Adult + prebava → alt = Vet-Sensitive (digestive option)
    // - Primary = Adult + allergens reduced pool → alt = Vet-Hypo (safe option)
    // - Primary = Adult, senior → alt = Vet-Senior (age-appropriate option)
    // - Primary = Adult, healthy → alt = 2nd best Adult flavor (flavor choice)
    let altProduct = null;
    if (mode === 'dry' && prods.length >= 1) {
      var primary = prods[0];
      var primaryIsSpecial = !!primary.special;
      var hasDigestion = S.healthConditions && S.healthConditions.includes('prebava');
      var hasOverweight = (parseInt((S.bodyCondition || '').toString().replace('bc','')) || 3) >= 4;
      var hasAllergies = alList.length > 0;
      var isSenior = S.lifeStage === 'senior';
      // Count how many Adult (non-special) products remain in pool
      var adultCount = pool.filter(function(p) { return !p.special; }).length;

      var alt = null;
      if (primaryIsSpecial) {
        // Primary is Vetactive → offer best Adult as alternative
        alt = pool.find(function(p) { return p.id !== primary.id && !p.special; });
      } else if (hasOverweight) {
        // Overweight → offer Vet-Light, fallback to 2nd Adult flavor
        alt = pool.find(function(p) { return p.special === 'light'; });
        if (!alt) alt = pool.find(function(p) { return p.id !== primary.id && !p.special; });
      } else if (hasDigestion) {
        // Digestion issues → offer Vet-Sensitive, fallback to 2nd Adult flavor
        alt = pool.find(function(p) { return p.special === 'sensitive'; });
        if (!alt) alt = pool.find(function(p) { return p.id !== primary.id && !p.special; });
      } else if (hasAllergies) {
        // Any allergies → offer Vet-Hypo as mono-protein alternative
        alt = pool.find(function(p) { return p.special === 'hypoallergenic' && p.id !== primary.id; });
        // Fallback: če Hypo ni v poolu (npr. alergija na Iberico/Krompir), ponudi 2. Adult okus
        if (!alt) alt = pool.find(function(p) { return p.id !== primary.id && !p.special; });
      } else if (isSenior) {
        // Senior → offer Vet-Senior as age-appropriate alternative
        var seniorProd = PRODUCTS.find(function(p) { return p.id === 'vet-senior'; });
        if (seniorProd && !S.allergens.some(function(a) { return seniorProd.allergens.includes(a); })) {
          alt = seniorProd;
        }
        if (!alt) alt = pool.find(function(p) { return p.id !== primary.id && !p.special; });
      } else {
        // Healthy dog → offer 2nd best Adult flavor (different taste, same quality)
        alt = pool.find(function(p) { return p.id !== primary.id && !p.special; });
      }

      if (alt) {
        altProduct = {...alt};
        altProduct.feeding = calcFeeding(altProduct, 'dry');
        altProduct.costs = calcCost(altProduct);
      }
    }

    // Feeding + cost
    prods.forEach(p => {
      p.feeding = calcFeeding(p, mode === 'combo' ? 'combo' : 'dry');
      p.costs = calcCost(p);
    });

    // MENU for wet/combo
    let menuPick = null, menuFeeding = null, menuCost = null, menuConflict = [];
    if (mode === 'wet' || mode === 'combo') {
      // Try flavor variety with first dry product
      let mp = menuPool.slice();
      if (menuIsLastResort && alList.length > 0) {
        // v9.34: Last resort sorts by WEIGHTED overlap - animal protein allergen
        // (PROTEIN_ALLERGENS) counts 10x more than plant allergen (Krompir/Riz).
        // Tie-break stays: prefer different flavor from dry among equal weights.
        var ovWeight = function(m) {
          return m.allergens.reduce(function(sum, al) {
            if (!alList.includes(al)) return sum;
            return sum + (PROTEIN_ALLERGENS.includes(al) ? 10 : 1);
          }, 0);
        };
        mp.sort((a, b) => ovWeight(a) - ovWeight(b));
        // Among items with same (lowest) weight, prefer different flavor from dry
        if (prods.length > 0 && mp.length > 1) {
          var minOv = ovWeight(mp[0]);
          var bestGroup = mp.filter(m => ovWeight(m) === minOv);
          if (bestGroup.length > 1) {
            var dryFl = prods[0].flavor;
            var diffFl = bestGroup.find(m => !m.flavor.some(f => dryFl.includes(f)));
            if (diffFl) mp = [diffFl, ...mp.filter(m => m.id !== diffFl.id)];
          }
        }
      } else if (prods.length > 0 && mp.length > 1) {
        const dryFlavors = prods[0].flavor;
        const diff = mp.find(m => !m.flavor.some(f => dryFlavors.includes(f)));
        if (diff) mp = [diff, ...mp.filter(m => m.id !== diff.id)];
      }
      menuPick = mp[0] || null;
      // v9.34: remember which of the dog's allergens the picked MENU contains
      // (non-empty only in last-resort case - pool is allergen-filtered otherwise)
      if (menuPick && alList.length > 0) {
        menuConflict = menuPick.allergens.filter(al => alList.includes(al));
      }
      if (menuPick) {
        if (mode === 'wet') {
          menuFeeding = calcFeeding(menuPick, 'wet');
          menuCost = calcWetCost(menuPick, menuFeeding.wet);
        } else {
          menuFeeding = { wet: prods[0].feeding.wet || 0 };
          menuCost = calcWetCost(menuPick, menuFeeding.wet);
        }
      }
    }

    byMode[mode] = { products: prods, altProduct: altProduct, menuPick, menuFeeding, menuCost, menuConflict, feedMode: mode };
  });

  // Default = always dry; suggest combo for picky dogs
  const defaultMode = 'dry';
  var suggestedMode = null;
  if (useScoring) {
    var modeRules = matchRules(signals, 'nacin_hranjenja');
    if (modeRules.length > 0) suggestedMode = modeRules[0].priporocilo_produkt;
  } else {
    suggestedMode = (S.eatingHabits === 'veryPicky') ? 'combo' : null;
  }

  // Upsells
  var ups;
  if (useScoring) {
    var upsellRules = matchRules(signals, 'upsell');
    var seen = {};
    ups = [];
    upsellRules.forEach(function(r) {
      var u = UPSELLS.find(function(u) { return u.name === r.priporocilo_produkt; });
      if (u && !seen[u.id]) { seen[u.id] = true; ups.push(u); }
    });
    // Default fallback: ko Supabase pravila ne ujamejo nobenega upsella
    if (ups.length === 0) {
      ups = UPSELLS.filter(function(u) { return u.trigger.includes('default'); });
    }
  } else {
    // Najprej zberemo specifične upselle (brez default triggerja)
    ups = UPSELLS.filter(u => {
      const pickyMatch = (S.eatingHabits === 'veryPicky' || S.eatingHabits === 'sometimes') && u.trigger.includes('picky');
      const healthMatch = S.healthConditions.some(hc => u.trigger.includes(hc));
      const seniorMatch = S.lifeStage === 'senior' && u.trigger.includes('senior');
      var _bcNum = parseInt((S.bodyCondition || '').toString().replace('bc','')) || 3;
      const bcMatch = (_bcNum >= 4 && u.trigger.includes('bc4'))
                   || (_bcNum >= 5 && u.trigger.includes('bc5'));
      const puppyMatch = S.lifeStage === 'puppy' && u.trigger.includes('puppy');
      const presuhMatch = _bcNum <= 2 && u.trigger.includes('presuh');
      const aktivenMatch = (S.activity === 'high' || S.activity === 'pro') && u.trigger.includes('aktiven');
      return pickyMatch || healthMatch || seniorMatch || bcMatch || puppyMatch || presuhMatch || aktivenMatch;
    });
    // Default trigger samo ko nič specifičnega ne ujame (zdrav adult brez posebnosti)
    if (ups.length === 0) {
      ups = UPSELLS.filter(u => u.trigger.includes('default'));
    }
  }
  // Filtriraj upselle po alergenih (pes alergičen na piščanca ne dobi piščančjih priboljškov)
  if (alList.length > 0) {
    ups = ups.filter(function(u) {
      if (!u.allergens || u.allergens.length === 0) return true;
      return !u.allergens.some(function(a) { return alList.includes(a); });
    });
  }
  // Za ne-picky scenarije: naključno obdrži samo 2 od 3+ Stars
  var isPicky = S.eatingHabits === 'veryPicky' || S.eatingHabits === 'sometimes';
  var starsInUps = ups.filter(function(u) { return u.id.includes('stars'); });
  if (!isPicky && starsInUps.length >= 3) {
    var removeIdx = Math.floor(Math.random() * starsInUps.length);
    var removeId = starsInUps[removeIdx].id;
    ups = ups.filter(function(u) { return u.id !== removeId; });
  }

  return { byMode, defaultMode, suggestedMode, upsells: ups, fallbackNotice };
}

// ===== FEEDING CALCULATOR =====
function interp(table, w) {
  if (w <= table[0].w) return table[0].d;
  if (w >= table[table.length-1].w) return table[table.length-1].d;
  for (let i = 0; i < table.length-1; i++) {
    if (w >= table[i].w && w <= table[i+1].w) {
      const r = (w - table[i].w) / (table[i+1].w - table[i].w);
      return Math.round(table[i].d + r * (table[i+1].d - table[i].d));
    }
  }
  return table[0].d;
}

function nearest(val, arr) {
  let best = arr[0], bd = Math.abs(val - best);
  for (const v of arr) { const d = Math.abs(val - v); if (d < bd) { bd = d; best = v; } }
  return best;
}

// Zaokroži grame navzgor na najbližji 5 (kot PLATINUM tabela)
function roundTo5(g) { return Math.ceil(g / 5) * 5; }

function calcFeeding(p, mode) {
  mode = mode || 'dry';
  const af = { low: 0.85, normal: 1.0, high: 1.2, pro: 1.4 };
  const actMul = af[S.activity] || 1;
  // Vet-Light: BC množilnik = ×1.0 (produkt sam zmanjša kcal za 22%)
  // BC4 = ×0.95 (rahlo pretežek), BC5 = ×0.9 (pretežek)
  var _bcVal = parseInt((S.bodyCondition || '').toString().replace('bc','')) || 3;
  const bcMul = (p.special === 'light') ? 1.0
    : (_bcVal >= 5 ? 0.9 : (_bcVal >= 4 ? 0.95 : (_bcVal <= 2 ? 1.1 : 1)));

  if (S.lifeStage === 'puppy') {
    const aw = nearest(S.adultWeightKg || S.weightKg, PW);
    const m = nearest(S.ageMonths || 6, [2,4,6,8,10,12]);
    const k = String(aw), mk = String(m);
    if (mode === 'wet') {
      const w = (PUPPY_WET[k] && PUPPY_WET[k][mk]) || 300;
      return { wet: roundTo5(Math.round(w * bcMul)) };
    }
    if (mode === 'combo') {
      const cd = (PUPPY_CD[k] && PUPPY_CD[k][mk]) || 75;
      const cw = (PUPPY_CW[k] && PUPPY_CW[k][mk]) || 150;
      return { dry: roundTo5(Math.round(cd * bcMul)), wet: roundTo5(Math.round(cw * bcMul)) };
    }
    // dry (default for puppies)
    const gpd = (PUPPY[k] && PUPPY[k][mk]) || 150;
    return { dry: roundTo5(Math.round(gpd * bcMul)) };
  }

  // Adult / Senior — brez senior množilnika (starost vpliva na izbor izdelka, ne na količino)
  if (mode === 'wet') {
    let w = interp(WET, S.weightKg);
    w = Math.round(w * actMul * bcMul);
    var wetResult = rerClamp({ wet: w }, p, 'wet');
    wetResult.wet = roundTo5(wetResult.wet);
    return wetResult;
  }
  if (mode === 'combo') {
    let cd = interp(p.fGroup === 2 ? CD2 : CD1, S.weightKg);
    let cw = interp(CWET, S.weightKg);
    cd = Math.round(cd * actMul * bcMul);
    cw = Math.round(cw * actMul * bcMul);
    return { dry: roundTo5(cd), wet: roundTo5(cw) };
  }
  // dry (default)
  let gpd = interp(p.fGroup === 2 ? FG2 : FG1, S.weightKg);
  gpd = Math.round(gpd * actMul * bcMul);
  var dryResult = rerClamp({ dry: gpd }, p, 'dry');
  dryResult.dry = roundTo5(dryResult.dry);
  return dryResult;
}

// RER clamp — prepreči padec pod bazalni metabolizem
function rerClamp(result, p, mode) {
  if (!p.kcal || !S.weightKg) return result;
  var rer = 70 * Math.pow(S.weightKg, 0.75);
  if (mode === 'dry' && result.dry) {
    var kcalRaw = result.dry * p.kcal / 100;
    if (kcalRaw < rer) {
      result.dry = Math.ceil(rer / (p.kcal / 100));
      result.rerClamped = true;
    }
  }
  if (mode === 'wet' && result.wet) {
    // Mokra hrana — dejanski kcal iz MENU izdelka (p.kcal, iz Supabase)
    var wetKcal = p.kcal || 160;
    var kcalWet = result.wet * wetKcal / 100;
    if (kcalWet < rer) {
      result.wet = Math.ceil(rer / (wetKcal / 100));
      result.rerClamped = true;
    }
  }
  return result;
}

function calcCost(p) {
  const dryGpd = p.feeding.dry || 0;
  return p.variants.map(v => ({
    ...v,
    cpd: Math.round((v.p / v.g) * dryGpd * 100) / 100,
    cpw: Math.round((v.p / v.g) * dryGpd * 7 * 100) / 100,
    cpm: Math.round((v.p / v.g) * dryGpd * 30 * 100) / 100,
    days: dryGpd > 0 ? Math.floor(v.g / dryGpd) : 0,
    weeks: dryGpd > 0 ? Math.round(v.g / dryGpd / 7 * 10) / 10 : 0
  }));
}

// Best CPD = najcenej\u0161i paket \u00d7 max qty popust (za "Že od X €/dan").
// v9.28: Shopify TRUNC-on-discount metoda \u2014 usklajeno z renderQtyTable
//        (brez double-rounding-a cpd \u2192 popust, kar je prej dajalo 1 cent razlike).
function calcBestCpdDry(costs, qtyTable, gpd) {
  if (!costs || costs.length === 0 || !gpd || gpd <= 0) return null;
  var avail = costs.filter(function(c) { return c.available !== false; });
  if (avail.length === 0) return null;
  var cheapest = avail.reduce(function(a, b) { return a.cpd < b.cpd ? a : b; });
  var maxRow = qtyTable[qtyTable.length - 1];
  // v9.32: round-on-total (nova Shopify discount konfiguracija) — usklajeno z renderQtyTable
  var total = Math.round(cheapest.p * maxRow.q * (1 - maxRow.d) * 100) / 100;
  return Math.round(total / (cheapest.g * maxRow.q) * gpd * 100) / 100;
}

function calcWetCost(menuItem, wetGpd, sizeIdx) {
  var si = (sizeIdx != null) ? sizeIdx : getDefaultWetIdx(menuItem);
  var sz = menuItem.sizes[si];
  var pricePerG = sz.p12 / (sz.g * 12);
  var cpd = Math.round(pricePerG * wetGpd * 100) / 100;
  var packs = Math.ceil(wetGpd / sz.g); // tetrapakov na dan
  return { cpd: cpd, cpw: Math.round(cpd * 7 * 100) / 100, cpm: Math.round(cpd * 30 * 100) / 100, packsDay: packs, sizeIdx: si, sizeLabel: sz.t };
}

// ===== EUR FORMAT HELPER =====
function fmtEur(n) { return n.toFixed(2).replace('.', ','); }

// ===== DEFAULT VARIANT HELPERS =====
// Suha hrana: do 6kg → 900g (idx 0), 7-11kg → 1.5kg (idx 1), 12kg+ → 5kg (idx 2)
// Stock-aware: če default OOS, preskoči na naslednjo available varianto
function getDefaultDryIdx(p) {
  var w = (S.lifeStage === 'puppy' ? S.adultWeightKg : null) || S.weightKg || 20;
  var idx = w <= 6 ? 0 : w <= 11 ? 1 : 2;
  if (idx >= p.costs.length) idx = p.costs.length - 1;
  // Če je default varianta OOS, poišči naslednjo available
  if (p.costs[idx] && p.costs[idx].available === false) {
    // Najprej poskusi večjo (idx+1, idx+2, ...)
    for (var i = idx + 1; i < p.costs.length; i++) {
      if (p.costs[i].available !== false) return i;
    }
    // Potem manjše (idx-1, idx-2, ...)
    for (var j = idx - 1; j >= 0; j--) {
      if (p.costs[j].available !== false) return j;
    }
    // Vse OOS — vrni original (bo prikazano kot OOS)
  }
  return idx;
}

// Mokra hrana: do 3kg → 90g (idx 0), 4-9kg → 185g (idx 1), 10kg+ → 375g (idx 2)
function getDefaultWetIdx(mp) {
  var w = (S.lifeStage === 'puppy' ? S.adultWeightKg : null) || S.weightKg || 20;
  var idx = w <= 3 ? 0 : w <= 9 ? 1 : 2;
  if (idx >= mp.sizes.length) idx = mp.sizes.length - 1;
  // Če je default OOS, preskoči
  if (mp.sizes[idx] && mp.sizes[idx].available === false) {
    for (var i = idx + 1; i < mp.sizes.length; i++) {
      if (mp.sizes[i].available !== false) return i;
    }
    for (var j = idx - 1; j >= 0; j--) {
      if (mp.sizes[j].available !== false) return j;
    }
  }
  return idx;
}

// Helper: determine primary "concern key" for timeline/quotes/benefits
function getQuoteKey() {
  if (S.eatingHabits === 'veryPicky') return 'veryPicky';
  if (S.eatingHabits === 'sometimes') return 'sometimes';
  if (S.healthConditions.includes('prebava')) return 'prebava';
  if (S.healthConditions.includes('skin')) return 'skin';
  if (S.lifeStage === 'senior') return 'senior';
  if (S.lifeStage === 'puppy') return 'puppy';
  if ((parseInt((S.bodyCondition || '').toString().replace('bc','')) || 3) >= 4) return 'teza';
  return 'default';
}

// ===== RENDER RESULTS =====
let RES_CACHE = null;

function renderFallbackNotice(notice, topProduct) {
  if (!notice) return '';
  const alList = S.allergens.filter(a => a !== 'brez');
  const alTxt = alList.length > 0 ? alList.join(', ') : '';
  const PROTEIN_COUNT = ['Piščanec','Govedina','Jagnjetina','Iberico (svinjina)','Puran','Riba','Račka'];
  const selectedProteins = alList.filter(a => PROTEIN_COUNT.includes(a));
  const prodName = topProduct ? topProduct.name : 'najboljšo razpoložljivo možnost';
  let txt;

  // Special case: 5+ protein allergens = vet recommendation
  if (selectedProteins.length >= 5) {
    txt = '🩺 <b>' + S.name + ' ima alergije na veliko beljakovinskih virov (' + selectedProteins.join(', ') + ').</b><br><br>V tem primeru priporočamo posvet z veterinarjem za eliminacijsko dieto. Spodaj priporočamo <b>' + prodName + '</b> — glede na profil tvojega psa je to trenutno najboljša izbira.<br><br>PLATINUM hrana je kuhana iz svežega mesa pri ~95°C (FSG metoda), ne iz mesne moke — zato so alergijske reakcije bistveno redkejše.';
  } else {
    const msgs = {
      'puppy-allergen': '🐶 <b>' + S.name + ' je mladič z alergijo na ' + alTxt + '.</b> Posebne puppy recepture brez tega alergena trenutno nimamo — spodaj priporočamo najboljšo alternativo iz odrasle linije.<br><br>PLATINUM hrana je kuhana iz svežega mesa pri ~95°C (FSG metoda), ne iz mesne moke — zato so alergijske reakcije bistveno redkejše. Priporočamo, da poskusiš — če tvoj pes reagira dobro, si našel pravo hrano. ✓',
      'senior-allergen': '🐕 <b>' + S.name + ' je starejši pes z alergijo na ' + alTxt + '.</b> Posebne senior recepture brez tega alergena trenutno nimamo — spodaj priporočamo najboljšo alternativo iz odrasle linije.<br><br>PLATINUM hrana je kuhana iz svežega mesa pri ~95°C (FSG metoda), ne iz mesne moke — zato so alergijske reakcije bistveno redkejše. Priporočamo, da poskusiš — če tvoj pes reagira dobro, si našel pravo hrano. ✓',
      'no-match': '📌 <b>Alergen: ' + alTxt + '</b> — recepture popolnoma brez tega alergena trenutno nimamo. Spodaj priporočamo najboljšo razpoložljivo možnost za ' + S.name + '.<br><br>PLATINUM hrana je kuhana iz svežega mesa pri ~95°C (FSG metoda), ne iz mesne moke — zato so alergijske reakcije bistveno redkejše kot pri industrijsko predelani hrani. Priporočamo, da poskusiš z manjšo količino — mnogi psi s to alergijo na PLATINUM reagirajo odlično. ✓'
    };
    txt = msgs[notice] || msgs['no-match'];
  }
  return '<div style="background:#FFF8E7;border:1.5px solid #E8C547;border-radius:12px;padding:16px 20px;margin-bottom:20px;font-size:14px;line-height:1.6;color:#5A4B1C">' + txt + '</div>';
}

// v9.34: opozorilo na wet kartici, ko izbrani MENU vsebuje oznacen alergen
// (last resort - noben MENU okus ni popolnoma brez oznacenih alergenov)
function renderMenuAllergenNotice(mp, conflict) {
  var dryData = RES_CACHE && RES_CACHE.byMode && RES_CACHE.byMode.dry;
  var dryP = dryData && dryData.products ? dryData.products[0] : null;
  var drySafe = dryP && !(RES_CACHE && RES_CACHE.fallbackNotice);
  var txt = '\u26A0\uFE0F <b>Pomembno za ' + S.name + ':</b> mokre hrane popolnoma brez ozna\u010denih alergenov \u017eal nimamo \u2014 vsak MENU okus vsebuje vsaj enega. <b>' + mp.name + '</b> je izbira z najmanj\u0161im tveganjem, a vsebuje: <b>' + conflict.join(', ') + '</b>.';
  if (drySafe) {
    txt += '<br><br>Za ' + S.name + ' zato priporo\u010damo suho hrano <b>' + dryP.name + '</b> (zavihek \u201eSuha hrana\u201c), ki ozna\u010denih alergenov ne vsebuje. \u010ce \u017eeli\u0161 kljub temu dodati mokro hrano, se prej posvetuj z veterinarjem.';
  } else {
    txt += '<br><br>Pred nakupom mokre hrane se posvetuj z veterinarjem.';
  }
  return '<div style="background:#FFF8E7;border:1.5px solid #E8C547;border-radius:12px;padding:16px 20px;margin-bottom:20px;font-size:14px;line-height:1.6;color:#5A4B1C">' + txt + '</div>';
}

function renderResults(res) {
  RES_CACHE = res;
  const c = document.getElementById('res-content');
  let h = '';
  h += '<div class="res-fade" style="animation-delay:0ms">' + renderResHeader() + '</div>';
  h += renderFallbackNotice(res.fallbackNotice, res.byMode[res.defaultMode].products[0]);
  h += '<div class="res-fade" style="animation-delay:100ms">' + renderFeedToggle(res.defaultMode, res.suggestedMode) + '</div>';
  h += '<div class="res-fade" style="animation-delay:200ms">' + renderTimeline() + '</div>';
  h += '<div id="feed-content" class="res-fade" style="animation-delay:300ms">';
  h += renderFeedContent(res.byMode[res.defaultMode]);
  h += renderTransition();
  h += '</div>';
  h += '<div class="res-fade" style="animation-delay:400ms">' + renderBottomSection(res) + '</div>';
  c.innerHTML = h;
  // Init sticky mobile CTA
  initStickyCta(res.byMode[res.defaultMode]);
}

function switchFeedMode(mode) {
  document.querySelectorAll('.feed-toggle-btn').forEach(b =>
    b.classList.toggle('sel', b.dataset.mode === mode));
  const fc = document.getElementById('feed-content');
  fc.innerHTML = renderFeedContent(RES_CACHE.byMode[mode]) + renderTransition();
  fc.scrollIntoView({behavior:'smooth', block:'start'});
  // Posodobi feed toggle hint
  var hint = document.getElementById('feed-hint');
  if (hint) hint.textContent = getFeedToggleHint(mode);
  // Posodobi sticky CTA z novim produktom
  initStickyCta(RES_CACHE.byMode[mode]);
}

function getResultsTitle() {
  const n = S.name;
  // Prioriteta: Zdravje > Ješčnost > Default
  if (S.healthConditions.includes('prebava')) return 'Zdrava prebava v 1\u20132 tednih \u2014 ' + n + ' plan';
  if (S.healthConditions.includes('skin')) return 'Zdrava ko\u017ea in sijo\u010da dlaka \u2014 ' + n + ' plan';
  if (S.healthConditions.includes('joints')) return 'Ve\u010d vitalnosti za ' + n + ' \u2014 personaliziran plan';
  if (S.eatingHabits === 'veryPicky') return n + ' bo kon\u010dno jedel z veseljem';
  if (S.eatingHabits === 'sometimes') return n + ' bo kon\u010dno jedel z veseljem';
  if ((parseInt((S.bodyCondition || '').toString().replace('bc','')) || 3) >= 4) return 'Zdrava te\u017ea za ' + n + ' \u2014 personaliziran plan';
  if (S.lifeStage === 'puppy') return n + ' PLATINUM plan za zdrav razvoj';
  if (S.lifeStage === 'senior') return 'Ve\u010d energije za ' + n + ' \u2014 personaliziran plan';
  return n + ' PLATINUM plan za polno energijo';
}

function renderResHeader() {
  const n = S.name;
  let h = '<div class="res-header">';
  h += '<h1>\u2705 ' + getResultsTitle() + '</h1>';

  // Summary — samo podatki
  const lifeLabel = {puppy:'mladič',adult:'odrasel pes',senior:'starejši pes'}[S.lifeStage] || 'pes';
  const actLabel = {low:'nizka aktivnost',normal:'normalna aktivnost',high:'visoka aktivnost',pro:'pro atlet'}[S.activity] || '';
  const tags = [S.weightKg + ' kg', lifeLabel, actLabel];
  if (S.eatingHabits === 'veryPicky') tags.push('zelo izbirčen');
  else if (S.eatingHabits === 'sometimes') tags.push('včasih izbirčen');
  if (S.healthConditions.includes('prebava')) tags.push('občutljiva prebava');
  if (S.healthConditions.includes('skin')) tags.push('občutljiva koža');
  if (S.healthConditions.includes('joints')) tags.push('sklepi');
  var bcNum = parseInt((S.bodyCondition || '').toString().replace('bc','')) || 3;
  if (bcNum >= 4) tags.push('prekomerna teža');
  var alDisp = S.allergens.filter(function(a) { return a !== 'brez'; });
  if (alDisp.length > 0) tags.push('alergija: ' + alDisp.join(', '));
  var summary = tags.join(' · ');
  h += '<div class="res-summary">' + summary + '</div>';
  h += '<a href="#" class="res-edit-link" onclick="restoreScr(1);showScr(1);return false">\u270F\uFE0F Spremeni odgovore</a>';
  h += '</div>';
  return h;
}

function getFeedToggleHint(mode) {
  if (mode === 'dry') {
    if (S.eatingHabits === 'veryPicky' || S.eatingHabits === 'sometimes') return 'Mehki briketi di\u0161ijo po mesu \u2014 idealni za izbirčne pse.';
    return 'Mehki briketi \u2014 pripravljeni, brez me\u0161anja.';
  }
  if (S.eatingHabits === 'veryPicky' || S.eatingHabits === 'sometimes') return 'Ekstra so\u010dna \u2014 idealna za izbirčne pse.';
  return 'Ekstra so\u010dna \u2014 83 % sve\u017eega mesa.';
}

function renderFeedToggle(defaultMode, suggestedMode) {
  let h = '<div class="feed-toggle-label">Izberi tip prehrane:</div>';
  h += '<div class="feed-toggle">';
  h += '<div class="feed-toggle-btn' + (defaultMode === 'dry' ? ' sel' : '') + '" data-mode="dry" onclick="switchFeedMode(\'dry\')">\uD83E\uDD63 Suha hrana</div>';
  h += '<div class="feed-toggle-btn' + (defaultMode === 'wet' ? ' sel' : '') + '" data-mode="wet" onclick="switchFeedMode(\'wet\')">\uD83E\uDD6B Mokra hrana</div>';
  h += '</div>';
  h += '<div class="feed-toggle-hint" id="feed-hint">' + getFeedToggleHint(defaultMode) + '</div>';
  return h;
}

function renderTimeline() {
  const n = S.name;
  const qk = getQuoteKey();
  let h = '<div class="timeline"><h3>Kaj pričakovati po prehodu na PLATINUM</h3>';

  h += '<div class="tl-phase"><div class="tl-phase-title">Prvi dnevi</div>';
  const tlP1 = {
    veryPicky: ['"Od \'ne je\' do \'zmaže\' – mehki briketi dišijo po mesu"', n + ' takoj začne jesti z veseljem'],
    sometimes: ['Mehki briketi dišijo po mesu – lažje navdušijo izbirčne pse', n + ' takoj začne jesti z veseljem'],
    prebava: ['Prebavni trakt sprejme FSG brikete brez šoka', 'Mehki briketi – lažje prebavljivo kot klasična suha hrana'],
    skin: ['Brez problematičnih sestavin od prvega obroka', 'Mono-proteinska receptura takoj razbremeni telo'],
    senior: ['Mehki briketi – lažje žvečenje, diši po mesu', n + ' takoj začne jesti z veseljem'],
    teza: ['Manjši, a polnovredni obroki – naravna hrana, ne dieta', n + ' bo pojedel z veseljem kljub manjšim porcijam'],
    default: ['Mehki briketi dišijo po mesu, ne po krmi', n + ' takoj začne jesti z veseljem']
  };
  (tlP1[qk] || tlP1.default).forEach(t => { h += '<div class="tl-item"><span>✅</span><span>' + t + '</span></div>'; });
  h += '</div>';

  h += '<div class="tl-phase"><div class="tl-phase-title">Teden 1–2</div>';
  const tlP2 = {
    veryPicky: ['Komaj čaka na obrok – ni več izbirčnosti', 'Prebava se umiri, čvrstejši kakci'],
    sometimes: ['Obroki postanejo rutina – je z veseljem', 'Prebava se umiri, čvrstejši kakci'],
    prebava: ['Prebava se vidno umirja – manj napihnjenosti', 'Čvrstejši kakci, manj diareje'],
    skin: ['Srbenje se zmanjšuje, manj praskanja', 'Koža se začne umirjati'],
    senior: ['Več energije in volje za sprehode', 'Prebava urejena, čvrsti kakci'],
    teza: ['Prebava urejena, čvrsti kakci', 'Energija ostaja – manj kalorij, ne manj hranilnih snovi'],
    default: ['Prebava urejena – čvrsti kakci', 'Več energije, boljše počutje']
  };
  (tlP2[qk] || tlP2.default).forEach(t => { h += '<div class="tl-item"><span>✅</span><span>' + t + '</span></div>'; });
  h += '</div>';

  h += '<div class="tl-phase"><div class="tl-phase-title">Teden 3–4</div>';
  const tlP3 = {
    veryPicky: ['Sijoča dlaka, zdrava koža', 'Popoln apetit – obroke zmaže v minutah'],
    sometimes: ['Sijoča dlaka, zdrava koža', 'Stabilni obroki, pes je z veseljem'],
    prebava: ['Stabilna prebava – čvrsti kakci vsak dan', 'Sijoča dlaka, več energije'],
    skin: ['Vidno manj rdečice in srbenja', 'Sijoča dlaka, zdrava koža'],
    senior: ['Lažje vstajanje, boljša mobilnost', 'Sijoča dlaka, več življenjske energije'],
    teza: ['Vidno vitkejša postava', 'Več energije, lažje gibanje, sijoča dlaka'],
    default: ['Sijoča dlaka, zdrava koža', 'Več energije, komaj čaka na vsak obrok']
  };
  (tlP3[qk] || tlP3.default).forEach(t => { h += '<div class="tl-item"><span>✅</span><span>' + t + '</span></div>'; });
  h += '</div></div>';
  return h;
}

function renderQtyTable(basePrice, packGrams, qtyTable, sizeLabel, tableId, gpd) {
  var h = '<div class="qty-tbl" id="' + tableId + '">';
  h += '<div class="qty-hdr" onclick="toggleQty(\'' + tableId + '\')">Več kupiš – več prihraniš 🔽</div>';
  h += '<div class="qty-body">';
  // v9.33: flat popust (WET_QTY 11 % za 2×-6×) → €/dan povsod enak, zato desna
  // kolona pokaže rastoči prihranek v €. Stopnjevan popust (DRY_QTY) ostane €/dan.
  var discRows = qtyTable.filter(function(r) { return r.q > 1; });
  var flatDisc = discRows.length > 0 && discRows[0].d > 0 &&
    discRows.every(function(r) { return r.d === discRows[0].d; });
  qtyTable.forEach(function(row, ri) {
    // v9.32: Shopify (nova discount konfiguracija 2026-08) zaokroža na TOTALU.
    // Primer 5kg base 41.20 × 4 × 0.77 = 126.896 → 126.90 (prej TRUNC per-unit → 126.92).
    var total = Math.round(basePrice * row.q * (1 - row.d) * 100) / 100;
    var pricePerG = total / (packGrams * row.q);
    var cpd = gpd > 0 ? Math.round(pricePerG * gpd * 100) / 100 : 0;
    var cpm = Math.round(cpd * 30 * 100) / 100;
    var days = gpd > 0 ? Math.round(packGrams * row.q / gpd) : 0;
    var saved = Math.round((basePrice * row.q - total) * 100) / 100;
    h += '<div class="qty-row' + (ri === 0 ? ' qty-sel' : '') + '" data-cpd="' + cpd + '" data-cpm="' + cpm + '" data-days="' + days + '" onclick="selQty(\'' + tableId + '\',' + ri + ')">';
    h += '<span class="qty-rad"></span><span class="qty-q">' + row.q + '× ' + sizeLabel + '</span>';
    h += '<span class="qty-p">' + fmtEur(total) + ' €</span>';
    h += '<span class="qty-kg">' + (flatDisc && saved > 0 ? 'prihraniš ' + fmtEur(saved) + ' €' : fmtEur(cpd) + ' €/dan') + '</span>';
    h += '</div>';
  });
  h += '</div>'; // close .qty-body
  h += '</div>';
  return h;
}

function toggleQty(tableId) {
  var tbl = document.getElementById(tableId);
  if (tbl) tbl.classList.toggle('qty-open');
}

function renderFeedContent(modeData) {
  const n = S.name;
  const fm = modeData.feedMode;
  let h = '';

  // ===== DRY MODE: 1 suhi produkt (slika | tekst) =====
  if (fm === 'dry') {
    const p = modeData.products[0];
    if (!p) return h;
    const dryGpd = p.feeding.dry || 0;
    const defIdx = getDefaultDryIdx(p);
    const def = p.costs[defIdx] || p.costs[0];

    h += '<div class="p-card">';
    h += '<div class="p-card-inner">';

    // LEFT: visual (badge + image)
    h += '<div class="p-card-visual">';
    h += '<span class="p-badge">Naše priporočilo za ' + n + '</span>';
    if (p.img) h += '<img src="' + p.img + '?width=400" alt="PLATINUM ' + p.name + '" class="p-card-img" loading="lazy">';
    h += '</div>';

    // RIGHT: content
    h += '<div class="p-card-content">';
    h += '<div class="p-name">PLATINUM ' + p.name + '</div>';

    // Price anchoring (TRUNC-on-discount, usklajeno z qty table)
    if (p.costs && p.costs.length > 0 && !p.outOfStock) {
      var bestCpd = calcBestCpdDry(p.costs, DRY_QTY, p.feeding.dry || 0);
      if (bestCpd) {
        h += '<div style="font-size:15px;color:var(--color-primary);font-weight:600;margin:-4px 0 14px">Že od ' + fmtEur(bestCpd) + ' €/dan</div>';
      }
    }

    h += '<div class="p-why"><h4>Zakaj ta hrana za ' + n + '?</h4>';
    var whyIntro = genWhyIntro(p);
    if (whyIntro) h += '<p class="why-intro">' + whyIntro + '</p>';
    genBenefits(p).forEach(b => { h += '<div class="ben"><span class="ben-i">✓</span><span>' + b + '</span></div>'; });
    h += '</div>';

    var qd = pickQuote(QUOTES_DRY, p.id);
    h += '<div class="sp-quote"><div class="sp-text">💬 "' + qd.text + '"</div><div class="sp-author">— ' + qd.author + ' · <span class="verified-badge">Preverjen kupec</span></div></div>';

    if (dryGpd > 0) {
      h += '<div class="feed-info">';
      h += '<div class="f-stat"><span class="f-val">' + dryGpd + ' g</span><span class="f-lbl">gramov / dan</span></div>';
      h += '<div class="f-stat"><span class="f-val">' + fmtEur(def.cpd) + ' €</span><span class="f-lbl">na dan</span></div>';
      h += '<div class="f-stat"><span class="f-val">' + fmtEur(def.cpm) + ' €</span><span class="f-lbl">na mesec</span></div>';
      h += '<div class="f-stat"><span class="f-val">~' + Math.max(1, Math.round(def.weeks)) + ' ted.</span><span class="f-lbl">paket ' + def.t + '</span></div>';
      h += '</div>';
    }

    h += '<div class="sizes" id="sz-' + p.id + '">';
    p.costs.forEach((v,vi) => {
      var isOos = v.available === false;
      if (isOos) {
        h += '<div class="sz oos" title="Trenutno ni na zalogi">';
        h += '<span class="sz-n">' + v.t + '</span><span class="sz-p oos-label">Ni na zalogi</span></div>';
      } else {
        h += '<div class="sz' + (vi === defIdx ? ' sel' : '') + '" onclick="selSz(\'' + p.id + '\',' + vi + ')">';
        h += '<span class="sz-n">' + v.t + '</span><span class="sz-p">' + fmtEur(v.p) + ' €</span><span class="sz-d">~' + v.days + ' dni</span></div>';
      }
    });
    h += '</div>';

    if (def.available !== false) {
      h += renderQtyTable(def.p, def.g, DRY_QTY, def.t, 'qty-' + p.id, dryGpd);
    }

    // Trust bar above ATC
    if (!p.outOfStock) {
      h += '<div class="trust-bar">';
      if (S.healthConditions.includes('prebava')) {
        h += '<span>📋 Postopen prehod v 5\u20137 dneh</span>';
      } else {
        h += '<span>✅ Prehod je takojšen</span>';
      }
      h += '<span>🛡️ 30-dnevna garancija</span>';
      h += '<span>🚚 Brezplačna dostava nad 29 \u20ac</span>';
      h += '</div>';
    }

    if (p.outOfStock) {
      h += '<button class="atc-btn oos-btn" onclick="notifyMe(\'' + p.handle + '\')">Obvesti me, ko je na voljo</button>';
      h += '<div class="atc-sub">Trenutno razprodano. Pustite email in vas obvestimo takoj.</div>';
    } else {
      h += '<button class="atc-btn" onclick="atc(\'' + p.handle + '\')">Naroči zdaj \u2013 brez tveganja</button>';
    }
    h += '</div>'; // close .p-card-content
    h += '</div>'; // close .p-card-inner
    h += '</div>'; // close .p-card

    // ===== ALTERNATIVE PRODUCT (different family: Vetactive vs Adult) =====
    if (modeData.altProduct) {
      h += renderAltCard(modeData.altProduct);
    }
  }

  // ===== WET MODE: samo MENU (slika | tekst) =====
  if (fm === 'wet' && modeData.menuPick) {
    const mp = modeData.menuPick;
    const wg = modeData.menuFeeding.wet || 0;
    const wc = modeData.menuCost;
    const wDefIdx = wc.sizeIdx;
    const wDefSz = mp.sizes[wDefIdx];

    // v9.34: last-resort opozorilo (MENU vsebuje oznacen alergen)
    if (modeData.menuConflict && modeData.menuConflict.length > 0) {
      h += renderMenuAllergenNotice(mp, modeData.menuConflict);
    }

    h += '<div class="p-card">';
    h += '<div class="p-card-inner">';

    // LEFT: visual
    h += '<div class="p-card-visual">';
    h += '<span class="p-badge">🥫 Priporočena mokra hrana</span>';
    if (mp.img) h += '<img src="' + mp.img + '?width=400" alt="PLATINUM ' + mp.name + '" class="p-card-img" loading="lazy">';
    h += '</div>';

    // RIGHT: content
    h += '<div class="p-card-content">';
    h += '<div class="p-name">PLATINUM ' + mp.name + '</div>';

    // Price anchoring for wet food (TRUNC-on-discount, usklajeno z qty table)
    if (mp.sizes && mp.sizes.length > 0 && wg > 0) {
      var availWetSizes = mp.sizes.filter(function(sz) { return sz.available !== false; });
      if (availWetSizes.length > 0) {
        // Najcenej\u0161i paket po gramu (12-pack cena)
        var cheapestWet = availWetSizes.reduce(function(a, b) {
          return (a.p12 / (a.g * 12)) < (b.p12 / (b.g * 12)) ? a : b;
        });
        var wetMaxRow = WET_QTY[WET_QTY.length - 1];
        var wDiscPerUnit = wetMaxRow.d > 0 ? Math.floor(cheapestWet.p12 * wetMaxRow.d * 100) / 100 : 0;
        var wTotal = Math.round((cheapestWet.p12 * wetMaxRow.q - wDiscPerUnit * wetMaxRow.q) * 100) / 100;
        var bestWetCpd = Math.round(wTotal / (cheapestWet.g * 12 * wetMaxRow.q) * wg * 100) / 100;
        h += '<div style="font-size:15px;color:var(--color-primary);font-weight:600;margin:-4px 0 14px">Že od ' + fmtEur(bestWetCpd) + ' €/dan</div>';
      }
    }

    h += '<div class="p-why">';
    const menuBenefits = [];
    menuBenefits.push('83% svežega mesa – visoko prebavljiva mokra hrana');
    if (S.eatingHabits === 'veryPicky' || S.eatingHabits === 'sometimes') menuBenefits.push('Pravi koščki mesa v omaki – tudi izbirni psi jo obožujejo');
    if (S.healthConditions.includes('prebava')) menuBenefits.push('Nežno za prebavni trakt – čvrsti kakci in konec napenjanja');
    if (S.lifeStage === 'senior') menuBenefits.push('Mehka tekstura – lažja za starejše pse');
    menuBenefits.push('Samo sveže meso, brez žit in umetnih dodatkov');
    menuBenefits.slice(0, 3).forEach(b => { h += '<div class="ben"><span class="ben-i">✓</span><span>' + b + '</span></div>'; });
    h += '</div>';

    var qw = pickQuote(QUOTES_WET, mp.id);
    h += '<div class="sp-quote"><div class="sp-text">💬 "' + qw.text + '"</div><div class="sp-author">— ' + qw.author + ' · <span class="verified-badge">Preverjen kupec</span></div></div>';

    h += '<div class="feed-info">';
    h += '<div class="f-stat"><span class="f-val">' + wg + ' g</span><span class="f-lbl">mokre hrane / dan</span></div>';
    h += '<div class="f-stat"><span class="f-val">' + fmtEur(wc.cpd) + ' €</span><span class="f-lbl">na dan</span></div>';
    h += '<div class="f-stat"><span class="f-val">' + fmtEur(wc.cpm) + ' €</span><span class="f-lbl">na mesec</span></div>';
    h += '<div class="f-stat"><span class="f-val">' + wc.packsDay + '×</span><span class="f-lbl">' + wDefSz.t + ' / dan</span></div>';
    h += '</div>';

    h += '<div class="sizes" id="sz-' + mp.id + '">';
    mp.sizes.forEach(function(sz, si) {
      var isOos = sz.available === false;
      if (isOos) {
        h += '<div class="sz oos" title="Trenutno ni na zalogi">';
        h += '<span class="sz-n">12× ' + sz.t + '</span><span class="sz-p oos-label">Ni na zalogi</span></div>';
      } else {
        h += '<div class="sz' + (si === wDefIdx ? ' sel' : '') + '" onclick="selWetSz(\'' + mp.id + '\',' + si + ')">';
        h += '<span class="sz-n">12× ' + sz.t + '</span><span class="sz-p">' + fmtEur(sz.p12) + ' €</span>';
        var packsDays = Math.round(sz.g * 12 / wg);
        h += '<span class="sz-d">~' + packsDays + ' dni</span></div>';
      }
    });
    h += '</div>';

    if (wDefSz.available !== false) {
      h += renderQtyTable(wDefSz.p12, wDefSz.g * 12, WET_QTY, '12×' + wDefSz.t, 'qty-' + mp.id, wg);
    }

    // Trust bar above ATC (wet)
    if (!mp.outOfStock) {
      h += '<div class="trust-bar">';
      if (S.healthConditions.includes('prebava')) {
        h += '<span>📋 Postopen prehod v 5\u20137 dneh</span>';
      } else {
        h += '<span>✅ Prehod je takojšen</span>';
      }
      h += '<span>🛡️ 30-dnevna garancija</span>';
      h += '<span>🚚 Brezplačna dostava nad 29 \u20ac</span>';
      h += '</div>';
    }

    if (mp.outOfStock) {
      h += '<button class="atc-btn oos-btn" onclick="notifyMe(\'' + mp.handle + '\')">Obvesti me, ko je na voljo</button>';
    } else {
      h += '<button class="atc-btn" onclick="atc(\'' + mp.handle + '\')">Naroči zdaj \u2013 brez tveganja</button>';
    }
    h += '</div>'; // close .p-card-content
    h += '</div>'; // close .p-card-inner
    h += '</div>'; // close .p-card
  }

  return h;
}

function renderAltCard(p) {
  var n = S.name;
  var dryGpd = p.feeding.dry || 0;
  var defIdx = getDefaultDryIdx(p);
  var def = p.costs[defIdx] || p.costs[0];
  var h = '';

  h += '<div class="p-card p-card-alt">';
  h += '<div class="p-card-inner">';

  // LEFT: visual
  h += '<div class="p-card-visual">';
  h += '<span class="p-badge p-badge-alt">Alternativa za ' + n + '</span>';
  if (p.img) h += '<img src="' + p.img + '?width=400" alt="PLATINUM ' + p.name + '" class="p-card-img" loading="lazy">';
  h += '</div>';

  // RIGHT: content
  h += '<div class="p-card-content">';
  h += '<div class="p-name">PLATINUM ' + p.name + '</div>';

  // Price anchoring (TRUNC-on-discount, usklajeno z qty table)
  if (p.costs && p.costs.length > 0 && !p.outOfStock) {
    var altBestCpd = calcBestCpdDry(p.costs, DRY_QTY, p.feeding.dry || 0);
    if (altBestCpd) {
      h += '<div style="font-size:15px;color:var(--color-primary);font-weight:600;margin:-4px 0 14px">\u017De od ' + fmtEur(altBestCpd) + ' \u20ac/dan</div>';
    }
  }

  h += '<div class="p-why"><h4>Zakaj ta hrana za ' + n + '?</h4>';
  genBenefits(p).forEach(function(b) { h += '<div class="ben"><span class="ben-i">\u2713</span><span>' + b + '</span></div>'; });
  h += '</div>';

  if (dryGpd > 0) {
    h += '<div class="feed-info">';
    h += '<div class="f-stat"><span class="f-val">' + dryGpd + ' g</span><span class="f-lbl">gramov / dan</span></div>';
    h += '<div class="f-stat"><span class="f-val">' + fmtEur(def.cpd) + ' \u20ac</span><span class="f-lbl">na dan</span></div>';
    h += '<div class="f-stat"><span class="f-val">' + fmtEur(def.cpm) + ' \u20ac</span><span class="f-lbl">na mesec</span></div>';
    h += '<div class="f-stat"><span class="f-val">~' + Math.max(1, Math.round(def.weeks)) + ' ted.</span><span class="f-lbl">paket ' + def.t + '</span></div>';
    h += '</div>';
  }

  h += '<div class="sizes" id="sz-' + p.id + '">';
  p.costs.forEach(function(v, vi) {
    var isOos = v.available === false;
    if (isOos) {
      h += '<div class="sz oos" title="Trenutno ni na zalogi">';
      h += '<span class="sz-n">' + v.t + '</span><span class="sz-p oos-label">Ni na zalogi</span></div>';
    } else {
      h += '<div class="sz' + (vi === defIdx ? ' sel' : '') + '" onclick="selSz(\'' + p.id + '\',' + vi + ')">';
      h += '<span class="sz-n">' + v.t + '</span><span class="sz-p">' + fmtEur(v.p) + ' \u20ac</span><span class="sz-d">~' + v.days + ' dni</span></div>';
    }
  });
  h += '</div>';

  if (def.available !== false) {
    h += renderQtyTable(def.p, def.g, DRY_QTY, def.t, 'qty-' + p.id, dryGpd);
  }

  // Trust bar
  if (!p.outOfStock) {
    h += '<div class="trust-bar">';
    if (S.healthConditions.includes('prebava')) {
      h += '<span>\uD83D\uDCCB Postopen prehod v 5\u20137 dneh</span>';
    } else {
      h += '<span>\u2705 Prehod je takojšen</span>';
    }
    h += '<span>\uD83D\uDEE1\uFE0F 30-dnevna garancija</span>';
    h += '<span>\uD83D\uDE9A Brezpla\u010dna dostava nad 29 \u20ac</span>';
    h += '</div>';
  }

  if (p.outOfStock) {
    h += '<button class="atc-btn oos-btn" onclick="notifyMe(\'' + p.handle + '\')">Obvesti me, ko je na voljo</button>';
  } else {
    h += '<button class="atc-btn" onclick="atc(\'' + p.handle + '\')">Naroči zdaj \u2013 brez tveganja</button>';
  }

  h += '</div>'; // close .p-card-content
  h += '</div>'; // close .p-card-inner
  h += '</div>'; // close .p-card
  return h;
}

function renderTransition() {
  const n = S.name;
  let h = '<div class="trans">';
  if (S.healthConditions.includes('prebava')) {
    h += '<h3>Prehod na PLATINUM za ' + n + '</h3>';
    h += '<p style="font-size:14px;color:var(--g700);line-height:1.6;margin-bottom:12px">Ker ima ' + n + ' ob\u010dutljiv \u017eelodec, priporo\u010damo <strong>postopen prehod v 7 dneh</strong>:</p>';
    h += '<div class="t-steps">';
    [{d:'Dan 1\u20132',o:75,n:25},{d:'Dan 3\u20134',o:50,n:50},{d:'Dan 5\u20136',o:25,n:75},{d:'Dan 7+',o:0,n:100}].forEach(s => {
      h += '<div class="t-step"><span class="t-days">' + s.d + '</span><div class="t-bar">';
      if (s.o) h += '<div class="old" style="width:' + s.o + '%"></div>';
      if (s.n) h += '<div class="nw" style="width:' + s.n + '%"></div>';
      h += '</div><span class="t-pct">' + s.n + '% PLATINUM</span></div>';
    });
    h += '</div>';
    h += '<div class="t-note">\uD83D\uDCA1 Postopoma zamenjuj staro hrano s PLATINUM v 7 dneh \u2014 25% \u2192 50% \u2192 75% \u2192 100%.</div>';
  } else {
    h += '<h3>✅ Takojšen prehod na PLATINUM</h3>';
    h += '<p style="font-size:14px;color:var(--g700);line-height:1.6">Zaradi posebne metode priprave – FSG je hrana PLATINUM zelo prebavljiva – do <strong>95% prebavljivost</strong>. ' + n + ' lahko takoj preide na novo hrano. Mešanje s staro hrano, zaradi različne prebavljivosti, ni priporočljivo.</p>';
  }
  h += '</div>';
  return h;
}

function renderBottomSection(res) {
  const n = S.name;
  let h = '';

  // Guarantee removed from here — now in trust-bar above ATC button

  // Upsells
  if (res.upsells.length > 0) {
    h += '<div class="ups-section"><h3>Dopolni ' + n + ' plan</h3>';
    res.upsells.slice(0, 3).forEach(u => {
      const upsIco = u.img ? '<img src="' + u.img + '?width=80" alt="' + u.name + '" class="ups-img">' : '<span class="ups-ico">' + u.icon + '</span>';
      h += '<div class="ups-card">' + upsIco + '<div class="ups-info"><div class="ups-n">PLATINUM ' + u.name + '</div><div class="ups-d">' + u.desc + '</div></div>';
      h += '<button class="ups-btn" onclick="atc(\'' + u.handle + '\')">+ ' + fmtEur(u.price) + ' €</button></div>';
    });
    h += '</div>';
  }

  // Email section
  if (S.email) {
    h += '<div class="email-sec"><div style="font-size:24px;margin-bottom:8px">✅</div>';
    h += '<h3>Plan poslan!</h3>';
    h += '<p>Preveri ' + S.email + ' — plan prehrane za ' + n + ' je na poti.</p></div>';
  } else {
    h += '<div class="email-sec"><h3>Prejmi ' + n + ' plan prehrane na email</h3>';
    h += '<p>Nasvete za prehod, priporočila in navodila — vse na enem mestu.</p>';
    h += '<div class="em-form"><input type="email" class="em-in" id="em-input" placeholder="tvoj@email.com" oninput="clearEmErr()">';
    h += '<div class="em-err" id="em-err"></div>';
    h += '<button class="em-btn" onclick="submitEmailFallback()">Pošlji mi plan →</button></div>';
    h += '<div class="em-perks"><span>✓ Plan prehrane</span><span>✓ Nasveti za prehod</span><span>✓ Brez spama</span></div>';
    h += '<div class="em-ok" id="em-ok">✓ Plan poslan na tvoj email!</div></div>';
  }

  // Why PLATINUM — HTML grid (matches original Figma design)
  h += '<div class="why-sec">';
  h += '<div class="why-sec-subtitle">Zakaj PLATINUM?</div>';
  h += '<h3>6 razlogov, ki naredijo razliko</h3>';
  h += '<div class="why-grid">';
  h += '<div class="why-card"><span class="why-icon">\uD83E\uDD69</span><strong>Sve\u017ee meso</strong><span>70% v vsaki porciji</span></div>';
  h += '<div class="why-card"><span class="why-icon">\u2668\uFE0F</span><strong>Po\u010dasno kuhano</strong><span>Ohranja hranilne snovi</span></div>';
  h += '<div class="why-card"><span class="why-icon">\uD83E\uDD0F</span><strong>Mehki briketi</strong><span>\u017Dve\u010dljivo in okusno</span></div>';
  h += '<div class="why-card"><span class="why-icon">\uD83D\uDC9A</span><strong>Ne nabrekne</strong><span>Varno za \u017eelodec</span></div>';
  h += '<div class="why-card"><span class="why-icon">\uD83D\uDC36</span><strong>Di\u0161i po mesu</strong><span>Ne po krmi</span></div>';
  h += '<div class="why-card"><span class="why-icon">\uD83C\uDFC6</span><strong>#1 v Nem\u010diji</strong><span>7 let zapored</span></div>';
  h += '</div></div>';

  // Free shipping nudge
  h += '<div style="text-align:center;padding:16px;font-size:14px;color:var(--g500)">⚡ Brezplačna dostava nad 29 €</div>';
  return h;
}

// ===== GENERATE BENEFITS =====
function genWhyIntro(p) {
  var n = S.name || 'tvoj pes';
  if (p.special === 'light') return n + ' ima nekaj kilogramov preve\u010d \u2014 Vetactive Light pomaga dose\u010di idealno te\u017eo z manj kalorij pri enaki porciji.';
  if (p.special === 'sensitive') return 'Ker ima ' + n + ' ob\u010dutljivo prebavo, priporo\u010damo Vetactive Sensitive \u2014 veterinarska formula z do 95% prebavljivostjo.';
  if (p.special === 'hypoallergenic') return 'Ker ima ' + n + ' alergije, priporo\u010damo Vetactive Hypoallergenic \u2014 samo ena vrsta beljakovin (Iberico), brez \u017eit.';
  if (p.special === 'senior') return n + ' je v zlati dobi \u2014 Vetactive Senior je prilagojen za starej\u0161e pse z manj kalorij in ve\u010d podpore za sklepe.';
  return '';
}

function genBenefits(p) {
  const b = [];
  b.push('70% sve\u017eega mesa \u2013 po\u010dasi kuhano pri ~95\u00b0C (FSG metoda)');

  if (S.lifeStage === 'puppy') b.push('Sve\u017ee meso za zdrav razvoj in veselega mladi\u010da');
  if (S.lifeStage === 'senior') b.push('Manj kalorij, ve\u010dja podpora za sklepe \u2013 aktivnej\u0161i dnevi v zlati dobi');

  if (p.special === 'sensitive') b.push('Do 95% prebavljivost \u2013 \u010dvrsti kakci v 1\u20132 tednih');
  else if (p.special === 'hypoallergenic') b.push('Samo ena vrsta beljakovin (Iberico svinjina) \u2013 brez \u017eit, manj tveganja za alergijo');
  else if (p.special === 'light') b.push('Manj kalorij pri enaki porciji \u2013 brez lakote do idealne te\u017ee');

  if (S.eatingHabits === 'veryPicky' || S.eatingHabits === 'sometimes') b.push('Mehki briketi \u2013 di\u0161ijo po sve\u017eem mesu, da jih zma\u017ee tudi najizbirnej\u0161i');
  else b.push('Mehki briketi \u2013 \u017eve\u010dljivo in okusno, ne nabrekne v \u017eelodcu');

  if (p.flavor.includes('Pi\u0161\u010danec') && !p.special && S.lifeStage !== 'puppy') b.push('Pi\u0161\u010danec \u2013 ne\u017een okus, priljubljen pri ve\u010dini psov');
  if (p.flavor.includes('Govedina')) b.push('Govedina \u2013 naravna alternativa za pse, ki ne prena\u0161ajo pi\u0161\u010dan\u010djega mesa');
  if (p.flavor.includes('Jagnjetina')) b.push('Jagnjetina \u2013 odli\u010dna alternativa za pse z alergijo na pi\u0161\u010danca');
  if (p.flavor.includes('Iberico') && p.special !== 'hypoallergenic') b.push('Iberico svinjina \u2013 redka vrsta mesa, brez \u017eit, manj alergij');

  return b.slice(0, 4);
}

// ===== QTY SELECTOR =====
function selQty(tableId, qi) {
  var tbl = document.getElementById(tableId);
  if (!tbl) return;
  // Označi izbrano vrstico
  tbl.querySelectorAll('.qty-row').forEach(function(r, i) { r.classList.toggle('qty-sel', i === qi); });
  var row = tbl.querySelectorAll('.qty-row')[qi];
  if (!row) return;

  var cpd = parseFloat(row.dataset.cpd) || 0;
  var cpm = parseFloat(row.dataset.cpm) || 0;
  var days = parseInt(row.dataset.days) || 0;
  var weeks = Math.round(days / 7 * 10) / 10;

  // Najdi parent p-card in feed-info
  var card = tbl.closest('.p-card');
  if (!card) return;
  var fi = card.querySelector('.feed-info');
  if (!fi) return;
  var stats = fi.querySelectorAll('.f-stat');

  // Posodobi €/dan
  if (stats[1]) stats[1].querySelector('.f-val').textContent = fmtEur(cpd) + ' €';
  // Posodobi €/mesec
  if (stats[2]) stats[2].querySelector('.f-val').textContent = fmtEur(cpm) + ' €';
  // Posodobi trajanje (stat[3]) — za dry: "traja X ted.", za wet: ohrani packs/dan
  if (stats[3] && days > 0) {
    var modeBtn = document.querySelector('.feed-toggle-btn.sel');
    var mode = modeBtn ? modeBtn.dataset.mode : 'dry';
    if (mode === 'dry') {
      stats[3].querySelector('.f-val').textContent = '~' + Math.max(1, Math.round(weeks)) + ' ted.';
      // Posodobi label z qty opisom (npr. "traja 3× 5 kg")
      var qtyLabel = row.querySelector('.qty-q');
      if (qtyLabel) stats[3].querySelector('.f-lbl').textContent = 'paket ' + qtyLabel.textContent.trim();
    }
  }

  // Posodobi sticky CTA ceno
  var scp = document.getElementById('sticky-cta-price');
  if (scp) scp.textContent = fmtEur(cpd) + ' €/dan';
}

// ===== SIZE SELECTOR =====
function selSz(pid, vi) {
  const el = document.getElementById('sz-' + pid);
  if (!el) return;
  el.querySelectorAll('.sz').forEach((s,i) => s.classList.toggle('sel', i === vi));

  // Posodobi feed-info cene za ta produkt
  const card = el.closest('.p-card');
  if (!card) return;
  const fi = card.querySelector('.feed-info');
  if (!fi) return;

  // Najdi produkt in varianto iz RES_CACHE
  const modeBtn = document.querySelector('.feed-toggle-btn.sel');
  const mode = modeBtn ? modeBtn.dataset.mode : 'dry';
  const modeData = RES_CACHE && RES_CACHE.byMode[mode];
  if (!modeData) return;
  const prod = modeData.products.find(function(p) { return p.id === pid; });
  if (!prod || !prod.costs[vi]) return;
  var v = prod.costs[vi];

  // Posodobi DOM — €/dan, €/mesec, trajanje
  var stats = fi.querySelectorAll('.f-stat');
  if (stats[1]) { // €/dan
    stats[1].querySelector('.f-val').textContent = fmtEur(v.cpd) + ' €';
  }
  if (stats[2]) { // €/mesec
    stats[2].querySelector('.f-val').textContent = fmtEur(v.cpm) + ' €';
  }
  if (stats[3]) { // trajanje
    stats[3].querySelector('.f-val').textContent = '~' + Math.max(1, Math.round(v.weeks)) + ' ted.';
    stats[3].querySelector('.f-lbl').textContent = 'paket ' + v.t;
  }

  // Posodobi sticky CTA ceno (samo za primary produkt)
  var scp = document.getElementById('sticky-cta-price');
  if (scp && prod === modeData.products[0]) {
    scp.textContent = fmtEur(v.cpd) + ' €/dan';
  }

  // Posodobi qty tabelo za novo velikost
  var qtyEl = document.getElementById('qty-' + pid);
  if (qtyEl) {
    var dryGpd = prod.feeding.dry || 0;
    var tmp = document.createElement('div');
    tmp.innerHTML = renderQtyTable(v.p, v.g, DRY_QTY, v.t, 'qty-' + pid, dryGpd);
    qtyEl.replaceWith(tmp.firstChild);
  }
}

// ===== WET SIZE SELECTOR =====
function selWetSz(menuId, si) {
  var el = document.getElementById('sz-' + menuId);
  if (!el) return;
  el.querySelectorAll('.sz').forEach(function(s, i) { s.classList.toggle('sel', i === si); });

  // Posodobi feed-info cene za mokro hrano
  var card = el.closest('.p-card');
  if (!card) return;
  var fi = card.querySelector('.feed-info');
  if (!fi) return;

  var modeBtn = document.querySelector('.feed-toggle-btn.sel');
  var mode = modeBtn ? modeBtn.dataset.mode : 'wet';
  var modeData = RES_CACHE && RES_CACHE.byMode[mode];
  if (!modeData || !modeData.menuPick) return;
  var mp = modeData.menuPick;
  var wg = modeData.menuFeeding.wet || 0;
  var sz = mp.sizes[si];
  var newCost = calcWetCost(mp, wg, si);

  var stats = fi.querySelectorAll('.f-stat');
  if (stats[1]) stats[1].querySelector('.f-val').textContent = fmtEur(newCost.cpd) + ' €';
  if (stats[2]) stats[2].querySelector('.f-val').textContent = fmtEur(newCost.cpm) + ' €';
  if (stats[3]) {
    stats[3].querySelector('.f-val').textContent = newCost.packsDay + '×';
    stats[3].querySelector('.f-lbl').textContent = sz.t + ' / dan';
  }

  // Posodobi qty tabelo za novo velikost
  var qtyEl = document.getElementById('qty-' + menuId);
  if (qtyEl) {
    var tmp = document.createElement('div');
    tmp.innerHTML = renderQtyTable(sz.p12, sz.g * 12, WET_QTY, '12×' + sz.t, 'qty-' + menuId, wg);
    qtyEl.replaceWith(tmp.firstChild);
  }
}

// ===== GA4 EVENT TRACKING =====
function ga4(event, params) {
  try { if (typeof gtag === 'function') gtag('event', event, params); } catch(e) {}
}

// ===== ADD TO CART =====
function productUrl(handle, medium) {
  return 'https://platinum.si/products/' + handle +
    '?utm_source=pet-food-finder&utm_medium=' + (medium || 'quiz') +
    '&utm_campaign=quiz-recommendation&utm_content=' + handle;
}

function atc(handle) {
  ga4('quiz_cta_click', { quiz_name: 'pet-food-finder', product_handle: handle });
  window.open(productUrl(handle, 'quiz'), '_blank');
}

function notifyMe(handle) {
  window.open(productUrl(handle, 'quiz'), '_blank');
}

// ===== STICKY MOBILE CTA =====
var _stickyHandle = '';
var _stickyObserver = null;

function initStickyCta(modeData) {
  var el = document.getElementById('sticky-cta');
  if (!el) return;
  var fm = modeData.feedMode;

  // Wet mode → prikaži MENU produkt; dry → prikaži suho hrano
  if (fm === 'wet' && modeData.menuPick) {
    var mp = modeData.menuPick;
    var wc = modeData.menuCost;
    document.getElementById('sticky-cta-name').textContent = 'PLATINUM MENU ' + mp.short;
    document.getElementById('sticky-cta-price').textContent = wc ? fmtEur(wc.cpd) + ' €/dan' : '';
    _stickyHandle = mp.handle;
  } else {
    var p = modeData.products[0];
    if (!p) { el.classList.remove('visible'); return; }
    var defIdx = getDefaultDryIdx(p);
    var def = p.costs[defIdx] || p.costs[0];
    document.getElementById('sticky-cta-name').textContent = 'PLATINUM ' + p.name;
    document.getElementById('sticky-cta-price').textContent = fmtEur(def.cpd) + ' €/dan';
    _stickyHandle = p.handle;
  }

  // Intersection Observer: prikaži sticky ko prvi atc-btn izgine
  if (_stickyObserver) _stickyObserver.disconnect();
  setTimeout(function() {
    var btn = document.querySelector('#feed-content .atc-btn');
    if (!btn) return;
    _stickyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        // Prikaži sticky ko CTA gumb ni viden IN smo na results screenu
        if (S.step === 9) {
          el.classList.toggle('visible', !e.isIntersecting);
        }
      });
    }, { threshold: 0 });
    _stickyObserver.observe(btn);
  }, 500);
}

function stickyAtc() {
  if (_stickyHandle) atc(_stickyHandle);
}

// ===== QUIZ SUBMISSION (n8n webhook) =====
function submitQuizData(res) {
  var dry = res.byMode.dry;
  var wet = res.byMode.wet;
  var combo = res.byMode.combo;
  var dryP1 = dry.products[0] || {};
  var dryP2 = dry.products[1] || null;
  var dryBestIdx = dryP1.costs ? getDefaultDryIdx(dryP1) : 0;
  var dryBest = dryP1.costs ? (dryP1.costs[dryBestIdx] || dryP1.costs[0]) : null;
  var altBestIdx = dryP2 && dryP2.costs ? getDefaultDryIdx(dryP2) : 0;
  var altBest = dryP2 && dryP2.costs ? (dryP2.costs[altBestIdx] || dryP2.costs[0]) : null;
  var comboP1 = combo.products[0] || {};
  var params = new URLSearchParams(window.location.search);

  var payload = {
    inputs: {
      petName: S.name,
      gender: S.gender,
      lifeStage: S.lifeStage,
      lifeStageOriginal: S._lifeStageOriginal || S.lifeStage,
      ageMonths: S.ageMonths,
      breed: S.breed,
      weightKg: S.weightKg,
      adultWeightKg: S.adultWeightKg,
      bodyCondition: ({1:'Presuh',3:'Idealen',4:'Malce pretežek',5:'Pretežek'})[S.bodyCondition] || S.bodyCondition,
      activity: S.activity,
      eatingHabits: S.eatingHabits,
      allergens: S.allergens,
      healthConditions: S.healthConditions.length > 0 ? S.healthConditions : ['brez'],
      currentFood: S.currentFood,
      currentBrand: S.currentBrand,
      email: S.email,
      emailOptin: S.emailOptin,
      utmSource: params.get('utm_source'),
      utmMedium: params.get('utm_medium'),
      utmCampaign: params.get('utm_campaign'),
      quizVersion: 'v9.35',
      dataSource: QUIZ_DATA.dataSource,
      quizDurationSec: S._startTime ? Math.round((Date.now() - S._startTime) / 1000) : null
    },
    results: {
      defaultMode: res.defaultMode,
      suggestedMode: res.suggestedMode,
      fallbackNotice: res.fallbackNotice,
      dryProduct1: dryP1.name || null,
      dryProduct1Id: dryP1.id || null,
      dryProduct2: dryP2 ? dryP2.name : null,
      dryProduct2Id: dryP2 ? dryP2.id : null,
      dryFeedingGpd: dryP1.feeding ? dryP1.feeding.dry : null,
      dryCostCpd: dryBest ? dryBest.cpd : null,
      dryCostBestCpd: (function() {
        if (!dryP1.costs) return null;
        var avail = dryP1.costs.filter(function(c) { return c.available !== false; });
        if (avail.length === 0) return null;
        var cheapest = avail.reduce(function(a, b) { return a.cpd < b.cpd ? a : b; });
        var maxD = DRY_QTY[DRY_QTY.length - 1].d;
        return Math.round(cheapest.cpd * (1 - maxD) * 100) / 100;
      })(),
      dryBestVariant: dryBest ? dryBest.t : null,
      wetMenu: wet.menuPick ? wet.menuPick.name : null,
      wetMenuId: wet.menuPick ? wet.menuPick.id : null,
      wetMenuConflict: (wet.menuConflict && wet.menuConflict.length > 0) ? wet.menuConflict : null,
      wetFeedingGpd: wet.menuFeeding ? wet.menuFeeding.wet : null,
      wetCostCpd: wet.menuCost ? wet.menuCost.cpd : null,
      dryCostCpm: dryBest ? dryBest.cpm : null,
      dryHandle: dryP1.handle || null,
      dryImg: dryP1.img || null,
      dryVariants: dryP1.costs ? JSON.stringify(dryP1.costs.map(function(c) { return {size:c.t,price:c.p,cpd:c.cpd,cpm:c.cpm,days:Math.round(c.days),available:c.available!==false}; })) : null,
      dryQty: JSON.stringify(DRY_QTY),
      dryAlt: dryP2 ? dryP2.name : null,
      dryAltHandle: dryP2 ? dryP2.handle : null,
      dryAltImg: dryP2 ? (dryP2.img || null) : null,
      dryAltGpd: dryP2 && dryP2.feeding ? dryP2.feeding.dry : null,
      dryAltCpd: altBest ? altBest.cpd : null,
      dryAltBestCpd: (function() {
        if (!dryP2 || !dryP2.costs) return null;
        var avail = dryP2.costs.filter(function(c) { return c.available !== false; });
        if (avail.length === 0) return null;
        var cheapest = avail.reduce(function(a, b) { return a.cpd < b.cpd ? a : b; });
        var maxD = DRY_QTY[DRY_QTY.length - 1].d;
        return Math.round(cheapest.cpd * (1 - maxD) * 100) / 100;
      })(),
      dryAltCpm: altBest ? altBest.cpm : null,
      dryAltBestSize: altBest ? altBest.t : null,
      wetHandle: wet.menuPick ? wet.menuPick.handle : null,
      wetCostCpm: wet.menuCost ? wet.menuCost.cpm : null,
      wetImg: (wet.menuPick && wet.menuPick.img) ? wet.menuPick.img : null,
      comboDryGpd: comboP1.feeding ? comboP1.feeding.dry : null,
      comboWetGpd: comboP1.feeding ? comboP1.feeding.wet : null,
      comboMenu: combo.menuPick ? combo.menuPick.name : null,
      comboMenuId: combo.menuPick ? combo.menuPick.id : null,
      comboWetCpd: combo.menuCost ? combo.menuCost.cpd : null,
      upsells: res.upsells.map(function(u) { return u.name; })
    }
  };

  fetch('https://igis-doo.app.n8n.cloud/webhook/pet-food-finder-submit', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  }).then(function(r) {
    console.log('Quiz submitted:', r.status);
  }).catch(function(err) {
    console.warn('Quiz submit failed (non-blocking):', err.message);
  });

  // Send to Email Flow (Klaviyo) if email is present
  if (S.email) {
    var emailRow = {
      email: S.email,
      pet_name: S.name,
      pet_type: 'dog',
      life_stage: S.lifeStage,
      age_months: S.ageMonths,
      weight_kg: S.weightKg,
      body_condition: S.bodyCondition,
      activity: S.activity,
      eating_habits: S.eatingHabits,
      health_conditions: S.healthConditions,
      allergens: S.allergens,
      breed: S.breed,
      gender: S.gender,
      current_food: S.currentFood,
      current_brand: S.currentBrand || '',
      dry_product_1: dryP1.id || null,
      dry_handle: dryP1.handle || null,
      dry_img: dryP1.img || null,
      dry_feeding_gpd: dryP1.feeding ? dryP1.feeding.dry : null,
      dry_cost_cpd: dryBest ? fmtEur(dryBest.cpd) : null,
      dry_cost_cpm: dryBest ? fmtEur(dryBest.cpm) : null,
      dry_best_variant: dryBest ? dryBest.t : null,
      dry_variants: dryP1.costs ? dryP1.costs.map(function(c) {
        return { size: c.t, price: fmtEur(c.p), cpd: fmtEur(c.cpd), days: String(Math.round(c.days)) };
      }) : [],
      dry_qty: DRY_QTY,
      dry_alt: dryP2 ? (dryP2.handle || dryP2.id) : null,
      dry_alt_handle: dryP2 ? dryP2.handle : null,
      dry_alt_img: dryP2 ? (dryP2.img || null) : null,
      dry_alt_gpd: dryP2 && dryP2.feeding ? dryP2.feeding.dry : null,
      dry_alt_cpd: altBest ? fmtEur(altBest.cpd) : null,
      dry_alt_cpm: altBest ? fmtEur(altBest.cpm) : null,
      wet_menu: wet.menuPick ? wet.menuPick.id : null,
      wet_handle: wet.menuPick ? wet.menuPick.handle : null,
      wet_img: (wet.menuPick && wet.menuPick.img) ? wet.menuPick.img : null,
      wet_feeding_gpd: wet.menuFeeding ? wet.menuFeeding.wet : null,
      wet_cost_cpd: wet.menuCost ? fmtEur(wet.menuCost.cpd) : null,
      wet_cost_cpm: wet.menuCost ? fmtEur(wet.menuCost.cpm) : null,
      wet_menu_conflict: (wet.menuConflict && wet.menuConflict.length > 0) ? wet.menuConflict : null,
      fallback_notice: res.fallbackNotice || null,
      transition_type: S.healthConditions.includes('prebava') ? 'gradual' : 'immediate',
      default_mode: res.defaultMode
    };
    fetch('https://igis-doo.app.n8n.cloud/webhook/pet-food-finder-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ row: emailRow })
    }).then(function(r) {
      console.log('📧 Email flow triggered:', r.status);
    }).catch(function(err) {
      console.warn('📧 Email flow failed (non-blocking):', err.message);
    });
  }
}

// ===== EMAIL FALLBACK (results page) =====
function clearEmErr() {
  var errEl = document.getElementById('em-err');
  var inp = document.getElementById('em-input');
  if (errEl) errEl.style.display = 'none';
  if (inp) inp.style.borderColor = '#e0e0e0';
}

function submitEmailFallback() {
  const email = document.getElementById('em-input').value.trim();
  const errEl = document.getElementById('em-err');
  const inp = document.getElementById('em-input');

  if (!email) {
    errEl.textContent = 'Vnesi email naslov';
    errEl.style.display = 'block';
    inp.style.borderColor = '#E53935';
    inp.focus();
    return;
  }
  if (!isValidEmail(email)) {
    errEl.textContent = 'Vnesi veljaven email (npr. ime@email.com)';
    errEl.style.display = 'block';
    inp.style.borderColor = '#E53935';
    inp.focus();
    return;
  }

  S.email = email;
  S.emailOptin = true;

  const payload = {
    email,
    petName: S.name,
    gender: S.gender,
    lifeStage: S.lifeStage,
    ageMonths: S.ageMonths,
    weightKg: S.weightKg,
    bodyCondition: S.bodyCondition,
    activity: S.activity,
    eatingHabits: S.eatingHabits,
    allergens: S.allergens,
    healthConditions: S.healthConditions,
    currentFood: S.currentFood
  };

  document.getElementById('em-ok').style.display = 'block';
  document.querySelector('.em-form').style.display = 'none';

  // NE kli\u010demo submitQuizData(RES_CACHE) \u2014 to bi re-sprozilo Dog Quiz Submit
  // workflow \u2192 2. Supabase INSERT + 2. QA Gmail alert. Email se po\u0161lje
  // samo preko direktnega fetcha v Email Flow (spodaj).

  // Send to Email Flow (Klaviyo)
  if (RES_CACHE) {
    var dry = RES_CACHE.byMode.dry;
    var wet = RES_CACHE.byMode.wet;
    var dryP = dry.products[0] || {};
    var dryP2 = dry.products[1] || null;
    var bIdx = dryP.costs ? getDefaultDryIdx(dryP) : 0;
    var dBest = dryP.costs ? (dryP.costs[bIdx] || dryP.costs[0]) : null;
    var aIdx = dryP2 && dryP2.costs ? getDefaultDryIdx(dryP2) : 0;
    var aBest = dryP2 && dryP2.costs ? (dryP2.costs[aIdx] || dryP2.costs[0]) : null;
    var emailRow = {
      email: email,
      pet_name: S.name,
      pet_type: 'dog',
      life_stage: S.lifeStage,
      age_months: S.ageMonths,
      weight_kg: S.weightKg,
      body_condition: S.bodyCondition,
      activity: S.activity,
      eating_habits: S.eatingHabits,
      health_conditions: S.healthConditions,
      allergens: S.allergens,
      breed: S.breed,
      gender: S.gender,
      current_food: S.currentFood,
      current_brand: S.currentBrand || '',
      dry_product_1: dryP.id || null,
      dry_handle: dryP.handle || null,
      dry_img: dryP.img || null,
      dry_feeding_gpd: dryP.feeding ? dryP.feeding.dry : null,
      dry_cost_cpd: dBest ? fmtEur(dBest.cpd) : null,
      dry_cost_cpm: dBest ? fmtEur(dBest.cpm) : null,
      dry_best_variant: dBest ? dBest.t : null,
      dry_variants: dryP.costs ? dryP.costs.map(function(c) {
        return { size: c.t, price: fmtEur(c.p), cpd: fmtEur(c.cpd), days: String(Math.round(c.days)) };
      }) : [],
      dry_qty: DRY_QTY,
      dry_alt: dryP2 ? (dryP2.handle || dryP2.id) : null,
      dry_alt_handle: dryP2 ? dryP2.handle : null,
      dry_alt_img: dryP2 ? (dryP2.img || null) : null,
      dry_alt_gpd: dryP2 && dryP2.feeding ? dryP2.feeding.dry : null,
      dry_alt_cpd: aBest ? fmtEur(aBest.cpd) : null,
      dry_alt_cpm: aBest ? fmtEur(aBest.cpm) : null,
      wet_menu: wet.menuPick ? wet.menuPick.id : null,
      wet_handle: wet.menuPick ? wet.menuPick.handle : null,
      wet_img: (wet.menuPick && wet.menuPick.img) ? wet.menuPick.img : null,
      wet_feeding_gpd: wet.menuFeeding ? wet.menuFeeding.wet : null,
      wet_cost_cpd: wet.menuCost ? fmtEur(wet.menuCost.cpd) : null,
      wet_cost_cpm: wet.menuCost ? fmtEur(wet.menuCost.cpm) : null,
      wet_menu_conflict: (wet.menuConflict && wet.menuConflict.length > 0) ? wet.menuConflict : null,
      fallback_notice: RES_CACHE.fallbackNotice || null,
      transition_type: S.healthConditions.includes('prebava') ? 'gradual' : 'immediate',
      default_mode: RES_CACHE.defaultMode
    };
    fetch('https://igis-doo.app.n8n.cloud/webhook/pet-food-finder-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ row: emailRow })
    }).then(function(r) {
      console.log('📧 Email flow triggered:', r.status);
    }).catch(function(err) {
      console.warn('📧 Email flow failed (non-blocking):', err.message);
    });
  }
}